import React, { useState } from "react";

import "./MedicalHistory.css";
import "../../Components/Commons/Commons.css";
import "quill/dist/quill.snow.css";
import "chart.js/auto";

import BtnAdd from "../Commons/Buttons/BtnAdd";
import NumberInput from "../Commons/Forms/NumberInput";
import TextField from "../Commons/Forms/TextField";
import TextArea from "../Commons/Forms/TextArea";
import BtnSave from "../Commons/Buttons/BtnSave";
import AntDTable from "../AntDTable/AntDTable";
import SelectField from "../Commons/Forms/SelectField";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import DeleteModal from "../Modals/DeleteModal";
import DateField from "../Commons/Forms/DateField";
import MedicalHistorySummary from "../PatientProfile/MedicalHistorySummary";
import dayjs from "dayjs";

import { Form, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Checkbox, DatePicker, InputNumber, List, Radio, Input, Button, Select } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  createAddObgyneHistory,
  createAllergy,
  createAsthma,
  createCancerFamilyProfile,
  createCancerProfile,
  createDiabetes,
  createDrinking,
  createDrug,
  createEndocrine,
  createExtrapulmonaryTBFamilyProfile,
  createExtrapulmonaryTBProfile,
  createGDM,
  createHepatitisFamilyProfile,
  createHepatitisProfile,
  createHerbal,
  createHeredofamilialDetails,
  createHypertension,
  createIllness,
  createLastHospitalization,
  createMedication,
  createPituitary,
  createPreGDM,
  createPulmonaryTBFamilyProfile,
  createPulmonaryTBProfile,
  createSmoking,
  createThyroid,
  createVaxProfile,
  deleteAllergy,
  deleteAsthma,
  deleteCancerFamilyProfile,
  deleteCancerProfile,
  deleteDiabetesApi,
  deleteDrinking,
  deleteDrug,
  deleteEndocrine,
  deleteExtrapulmonaryTBFamilyProfile,
  deleteExtrapulmonaryTBProfile,
  deleteGDM,
  deleteHepatitisFamilyProfile,
  deleteHepatitisProfile,
  deleteHerbal,
  deleteHeredofamilial,
  deleteHospitalization,
  deleteHypertension,
  deleteIllness,
  deleteMedication,
  deleteObgyneHistory,
  deletePituitary,
  deletePreGDM,
  deletePulmonaryTBFamilyProfile,
  deletePulmonaryTBProfile,
  deleteSmoking,
  deleteThyroid,
  deleteVaxProfile,
  editAllergy,
  editAsthma,
  editCancerFamilyProfile,
  editCancerProfile,
  editDiabetes,
  editDrinking,
  editDrug,
  editEndocrine,
  editExtrapulmonaryTBFamilyProfile,
  editExtrapulmonaryTBProfile,
  editGDM,
  editHepatitisFamilyProfile,
  editHepatitisProfile,
  editHerbal,
  editHypertension,
  editIllness,
  editLastHospitalization,
  editMedication,
  editObgyneHistory,
  editPituitary,
  editPreGDM,
  editPulmonaryTBFamilyProfile,
  editPulmonaryTBProfile,
  editSmoking,
  editThyroid,
  editVaxProfile,
  getAllergy,
  getAsthma,
  getCancerFamilyProfile,
  getCancerProfile,
  getDiabetes,
  getDrinking,
  getDrug,
  getEndocrine,
  getExtrapulmonaryTBFamilyProfile,
  getExtrapulmonaryTBProfile,
  getGDM,
  getHepatitisFamilyProfile,
  getHepatitisProfile,
  getHerbal,
  getHeredofamilial,
  getHospitalization,
  getHypertension,
  getIllness,
  getMedication,
  getObgyneHistory,
  getPituitary,
  getPreGDM,
  getPulmonaryTBFamilyProfile,
  getPulmonaryTBProfile,
  getSmoking,
  getThyroid,
  getVaccinationShots,
  getVaxProfile,
  getYakapImmunization,
  createImmunization,
  editImmunization,
  deleteImmunization,
  getImmunization,
} from "../Helpers/API/MedicalHistoryApi/MedicalHistoryApi";
import { getRole } from "../Helpers/Utilities/Common";
import { toast } from "react-toastify";
import PastMedicalHistory from "./PastMedicalHistory";
import {
  validateAllergy,
  validateAsthma,
  validateCancerProfile,
  validateDiabetes,
  validateDrinking,
  validateDrug,
  validateEndocrine,
  validateHepatitisProfile,
  validateHerbal,
  validateHeredoFamilial,
  validateHospitalization,
  validateHypertension,
  validateIllness,
  validateMedication,
  validatePituitary,
  validateSmoking,
  validateTBProfile,
  validateThyroid,
  validateVaxProfile,
} from "../Helpers/Utilities/Validations/MedicalHistoryHospitalization";
import { formatDate } from "../../Assets/Helpers/Common";
import { heredofamilialDiseases } from "../../Constants/heredofamilialDiseases";
import { isPatientMale } from "../PatientProfile/historyCompletion";

const INITIAL_OBGYNE_HISTORY = {
  id: "",
  has_family_planning: "0",
  is_sexually_active: "0",
  menarche: "",
  last_mens_period: "",
  period_duration: "",
  mens_interval: "",
  pads_per_day: "",
  onset_sex_ic: "",
  birth_ctrl_method: "",
  is_menopause: "N",
  gravidity: "",
  parity: "",
  delivery_type: "",
  menopause_age: "",
  full_term_cnt: "",
  premature_cnt: "",
  abortion_cnt: "",
  living_children_cnt: "",
  preg_ind_hyp: "N",
  is_pregnancy_history_applicable: "0",
};

const deliveryTypeOptions = [
  { value: "N", label: "Normal (NSD)" },
  { value: "O", label: "Operative (CSD)" },
  { value: "B", label: "Both Normal & Operative" },
  { value: "X", label: "Not Applicable" },
];

function AddMedical({
  allergyData,
  setAllergyData,
  refreshHistoryCompletion,
  patientSex,
}) {
  const id = useParams();
  const role = getRole();
  const isMalePatient = isPatientMale(patientSex);
  const notifyHistoryChange = () => {
    if (refreshHistoryCompletion) refreshHistoryCompletion();
  };
  const [showDelete, setShowDelete] = useState(false);
  const [showLoader, setShowLoader] = useState(false); // table loader
  const [showButton, setShowButton] = useState(false); // button loader
  const [gdmEdit, setGdmEdit] = useState("edit"); // GDM
  const [preGdmEdit, setPreGdmEdit] = useState("edit"); // PRE GDM
  const [vaccinationShots, setVaccinationShots] = useState([]); // list of vaccination shots
  const [selectedItem, setSelectedItem] = useState(0);
  const [showDeleteBtn, setShowDeleteBtn] = useState(false); // GDM DELETE BTN
  const [showDeleteHeredofamilialBtn, setShowHeredofamilialDeleteBtn] =
    useState(false); // Heredofamilial DELETE BTN
  const [showDeletePreGDMBtn, setShowDeletePreGDMBtn] = useState(false); // GDM DELETE BTN

  const [isMedicalHistory, setIsMedicalHistory] = useState(true);
  const [isSelected, setIsSelected] = useState("Past Medical History");

  const [isError, setError] = useState({
    name: false,
    admitted_on: false,
    reason: false,
    type: false,
    duration: false,
    last_attack: false,
    usual_fbs: false,
    usual_rbs: false,
    hba1c: false,
    cbg_range: false,
    complications: false,
    generic: false,
    brand: false,
    preparation: false,
    form: false,
    dosage: false,
    frequency: false,
    timing: false,
    compliance: false,
    highest_bp: false,
    usual_bp: false,
    last_intake: false,
    medication: false,
    rai: false,
    surgery: false,
    levothyroxine: false,
    histopathologic: false,
    sticks_per_day: false,
    consumption: false,
    aog: false,
    fasting: false,
    glucose_load_1h: false,
    glucose_load_2h: false,
    insulin_use: false,
    handout_link: false,
    gdm_profile_id: false,
    others: false,
    vax_shot_id: false,
    taken_on: false,
    next_shot_on: false,
  });
  const [addHospitalization, setAddHospitalization] = useState({
    id: "",
    name: "",
    admitted_on: "",
    reason: "",
  });
  const [addAllergy, setAddAllergy] = useState({
    id: "",
    name: "",
    type: "drug",
  });
  const [addAsthma, setAddAsthma] = useState({
    id: "",
    duration: "",
    last_attack: "",
  });
  const [addDiabetes, setAddDiabetes] = useState({
    id: "",
    duration: "",
    usual_fbs: "",
    usual_rbs: "",
    hba1c: "",
    cbg_range: "preprandial",
    complications: "",
  });
  const [addMedication, setAddMedication] = useState({
    id: "",
    generic: "",
    brand: "",
    preparation: "",
    form: "",
    dosage: "",
    frequency: "",
    timing: "",
    duration: "",
    compliance: "fair",
  });
  const [addHypertension, setAddHypertension] = useState({
    id: "",
    duration: "",
    highest_bp: "",
    usual_bp: "",
  });
  const [addHerbal, setAddHerbal] = useState({
    id: "",
    name: "",
    last_intake: "",
    duration: "",
  });
  const [addThyroid, setAddThyroid] = useState({
    id: "",
    type: "",
    duration: "",
    medication: "",
    rai: "",
    surgery: "",
    levothyroxine: "",
    histopathologic: "",
  });
  const [addPituitary, setAddPituitary] = useState({
    id: "",
    name: "",
  });
  const [addEndocrine, setAddEndocrine] = useState({
    id: "",
    name: "",
  });
  const [addIllness, setAddIllness] = useState({
    id: "",
    name: "",
  });
  const [addSmoking, setAddSmoking] = useState({
    id: "",
    duration: "",
    sticks_per_day: "",
  });
  const [addDrinking, setAddDrinking] = useState({
    id: "",
    frequency: "occasional",
    consumption: "light",
    btl_per_day: "",
  });
  const [addDrug, setAddDrug] = useState({
    id: "",
    name: "",
    last_intake: "",
  });
  const [addHeredofamilial, setAddHeredofamilial] = useState({
    id: "",
    default_diseases: [],
    others: "",
  });
  const [addGDM, setAddGDM] = useState({
    id: "",
    aog: "",
    fasting: "",
    glucose_load_1h: "",
    glucose_load_2h: "",
    insulin_use: "",
    handout_link: "",
    gdm_profile_id: "",
  });
  const [addPreGDM, setAddPreGDM] = useState({
    id: "",
    aog: "",
    hba1c: "",
    fasting: "",
    glucose_load_1h: "",
    glucose_load_2h: "",
    insulin_use: "",
    handout_link: "",
    pre_gdm_profile_id: "",
  });
  // const [addVax, setAddVax] = useState({
  //   id: "",
  //   vax_shot_id: "",
  //   lot_number: "",
  //   expiry_date: "",
  //   route_injection: "",
  //   manufacturing_no_brand: "",
  //   taken_on: "",
  //   next_shot_on: "",
  // });

  const [addVax, setAddVax] = useState({
    id: "",
    patient_id: "",
    assessment_id: "",
    child_imm_code: [],
    youngw_imm_code: [],
    pregw_imm_code: [],
    elderly_imm_code: [],
    other_imm: [],
  });

  const [addCancer, setAddCancer] = useState({
    id: "",
    organ: "",
  });
  const [addCancerFamily, setAddCancerFamily] = useState({
    id: "",
    organ: "",
  });

  const [addHepatitis, setAddHepatitis] = useState({
    id: "",
    type: "",
  });
  const [addHepatitisFamily, setAddHepatitisFamily] = useState({
    id: "",
    type: "",
  });

  const [addPulmonaryTB, setAddPulmonaryTB] = useState({
    id: "",
    category: "",
  });
  const [addPulmonaryTBFamily, setAddPulmonaryTBFamily] = useState({
    id: "",
    category: "",
  });

  const [addExtrapulmonaryTB, setAddExtrapulmonaryTB] = useState({
    id: "",
    category: "",
  });
  const [addExtrapulmonaryTBFamily, setAddExtrapulmonaryTBFamily] = useState({
    id: "",
    category: "",
  });
  const [addObgyneHistory, setAddObgyneHistory] =
    useState(INITIAL_OBGYNE_HISTORY);

  const [lastHospitalizationDatas, setLastHospitalizationDatas] = useState([]);
  const [asthmaDatas, setAsthmaDatas] = useState([]);
  const [diabetesDatas, setDiabetesDatas] = useState([]);
  const [medicationDatas, setMedicationDatas] = useState([]);
  const [hypertensionDatas, setHypertensionDatas] = useState([]);
  const [herbalDatas, setHerbalDatas] = useState([]);
  const [thyroidDatas, setThyroidDatas] = useState([]);
  const [pituitaryDatas, setPituitaryDatas] = useState([]);
  const [endocrineDatas, setEndocrineDatas] = useState([]);
  const [illnessDatas, setIllnessDatas] = useState([]);
  const [smokingDatas, setSmokingDatas] = useState([]);
  const [drinkingDatas, setDrinkingDatas] = useState([]);
  const [drugDatas, setDrugDatas] = useState([]);
  const [vaxShot, setVaxShot] = useState([]);
  const [cancerDatas, setCancerDatas] = useState([]);
  const [cancerFamilyDatas, setCancerFamilyDatas] = useState([]);
  const [hepatitisDatas, setHepatitisDatas] = useState([]);
  const [hepatitisFamilyDatas, setHepatitisFamilyDatas] = useState([]);
  const [pulmonaryTBDatas, setPulmonaryTBDatas] = useState([]);
  const [pulmonaryTBFamilyDatas, setPulmonaryTBFamilyDatas] = useState([]);
  const [extrapulmonaryTBDatas, setExtrapulmonaryTBDatas] = useState([]);
  const [extrapulmonaryTBFamilyDatas, setExtrapulmonaryTBFamilyDatas] =
    useState([]);
  const [obgyneDatas, setObgyneDatas] = useState([]);
  const [isEdit, setIsEdit] = useState("");
  const [familyInputs, setFamilyInputs] = useState({
    Allergy: [""],
    Cancer: [""],
    Hepatitis: "",
    Hypertension: "",
    Tuberculosis: "",
    "Extrapulmonary Tuberculosis": "",
  });
  const [heredofamilialDatas, setHeredofamilialDatas] = useState([]);
  const [childImmOptions, setChildImmOptions] = useState([]);
  const [youngImmOptions, setYoungImmOptions] = useState([]);
  const [pregImmOptions, setPregImmOptions] = useState([]);
  const [elderlyImmOptions, setElderlyImmOptions] = useState([]);

  // List fo tabs in Add Medical
  const listTabs = [
    { id: 0, label: "Past Medical History" },
    { id: 1, label: "Family Past Medical History" },
    { id: 27, label: "OB-Gyne History" },
    { id: 2, label: "Hypertension" },
    { id: 3, label: "Diabetes" }, 
    { id: 4, label: "Thyroid Disorders" },
    { id: 5, label: "GDM" },
    { id: 6, label: "Pre-GDM" },
    { id: 7, label: "Pituitary Disorders" },
    { id: 8, label: "Other Endocrine Diseases" },
    { id: 7, label: "Bronchial Asthma" },
    { id: 8, label: "Other Illness" },
    { id: 9, label: "Maintenance Medication" },
    { id: 10, label: "Food/Drug Allergy" },
    // { id: 11, label: "Smoking" },
    // { id: 12, label: "Drinking" },
    // { id: 13, label: "Illicit Drug Use" },
    // { id: 14, label: "Herbal Use" },
    { id: 17, label: "Surgeries" },
    { id: 18, label: "Vaccination" },
    { id: 19, label: "Cancer" },
    { id: 20, label: "Family Cancer Profile" },
    { id: 21, label: "Hepatitis" },
    { id: 22, label: "Family Hepatitis Profile" },
    { id: 23, label: "Pulmonary Tuberculosis" },
    { id: 24, label: "Family Pulmonary Tuberculosis Profile" },
    { id: 25, label: "Extrapulmonary Tuberculosis" },
    { id: 26, label: "Family Extrapulmonary Tuberculosis Profile" },
  ];

  // Function for handling the value in add medical tab
  const handleChange = (data, index) => {
    if (data.label === "OB-Gyne History" && isMalePatient) return;
    setSelectedItem(index);
    setIsSelected(data.label);
  };

  // Function for handling the value in Heredofamilial tab
  const handleAddHeredofamilialChange = (e, index, select) => {
    const { name, value } = e.target;
    setAddHeredofamilial((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const toggleHeredoDisease = (val, checked) => {
    setAddHeredofamilial((prev) => {
      const arr = new Set(prev.default_diseases || []);
      if (checked) arr.add(val);
      else arr.delete(val);
      return { ...prev, default_diseases: Array.from(arr) };
    });
  };
  const setFamilyDetail = (key, index, value) => {
    setFamilyInputs((prev) => {
      if (Array.isArray(prev[key])) {
        const arr = [...prev[key]];
        arr[index] = value;
        return { ...prev, [key]: arr };
      }
      return { ...prev, [key]: value };
    });
  };
  const addFamilyDetailItem = (key) => {
    setFamilyInputs((prev) => {
      const arr = Array.isArray(prev[key]) ? [...prev[key]] : [];
      arr.push("");
      return { ...prev, [key]: arr };
    });
  };
  const removeFamilyDetailItem = (key, index) => {
    setFamilyInputs((prev) => {
      const arr = Array.isArray(prev[key]) ? [...prev[key]] : [];
      arr.splice(index, 1);
      return { ...prev, [key]: arr.length ? arr : [""] };
    });
  };

  // Function for handling the value in Hospitalization tab
  const handleAddHospitalizationChange = (e) => {
    const { name, value } = e.target;
    setAddHospitalization((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Diabetes tab
  const handleAddDiabetesChange = (e) => {
    const { name, value } = e.target;
    setAddDiabetes((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Allergy tab
  const handleAddAllergyChange = (e) => {
    const { name, value } = e.target;
    setAddAllergy((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Asthma tab
  const handleAddAsthmaChange = (name, value) => {
    setAddAsthma((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Medication tab
  const handleAddMedicationChange = (e) => {
    const { name, value } = e.target;
    setAddMedication((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Hypertension tab
  const handleAddHypertensionChange = (e) => {
    const { name, value } = e.target;
    setAddHypertension((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Herbal tab
  const handleAddHerbalChange = (e) => {
    const { name, value } = e.target;
    setAddHerbal((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Thyroid tab
  const handleAddThyroidChange = (e) => {
    const { name, value } = e.target;
    setAddThyroid((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Pituitary tab
  const handleAddPituitaryChange = (e) => {
    const { name, value } = e.target;
    setAddPituitary((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Endocrine tab
  const handleAddEndocrineChange = (e) => {
    const { name, value } = e.target;
    setAddEndocrine((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Illness tab
  const handleAddIllnessChange = (e) => {
    const { name, value } = e.target;
    setAddIllness((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Smoking tab
  const handleAddSmokingChange = (e) => {
    const { name, value } = e.target;
    setAddSmoking((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Drinking tab
  const handleAddDrinkingChange = (e) => {
    const { name, value } = e.target;
    setAddDrinking((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Frug tab
  const handleAddDrugChange = (e) => {
    const { name, value } = e.target;
    setAddDrug((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in GDM tab
  const handleAddGDMChange = (e) => {
    const { name, value } = e.target;
    setAddGDM((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Pre GDM tab
  const handleAddPreGDMChange = (e) => {
    const { name, value } = e.target;
    setAddPreGDM((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Vaxx tab
  const handleAddVaxChange = (e) => {
    const { name, value } = e.target;
    setAddVax((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the multi-select values in Vaxx tab
  const handleAddVaxMultiChange = (name, value) => {
    setAddVax((prevState) => ({
      ...prevState,
      [name]: value || [],
    }));
  };

  // Normalizes a stored immunization code (single id, comma-separated string,
  // or array) into an array so it works with the multiple select
  const toImmArray = (val) => {
    if (Array.isArray(val)) return val;
    if (val === null || val === undefined || val === "") return [];
    if (typeof val === "string" && val.includes(","))
      return val.split(",").map((v) => v.trim()).filter(Boolean);
    return [val];
  };

  const hasVaxSelection =
    (addVax.child_imm_code || []).length > 0 ||
    (addVax.youngw_imm_code || []).length > 0 ||
    (addVax.pregw_imm_code || []).length > 0 ||
    (addVax.elderly_imm_code || []).length > 0 ||
    toImmArray(addVax.other_imm).length > 0;

  // Flattens each saved vaccination record into one table row per immunization
  // (Type + Immunization). Every row keeps the original record's fields so the
  // Edit button still receives the full record.
  const vaxTableRows = (vaxShot || []).flatMap((record) => {
    const toDescArray = (val) =>
      (Array.isArray(val) ? val : [val]).filter(
        (v) =>
          v !== null &&
          v !== undefined &&
          String(v).trim() !== "" &&
          String(v).trim().toLowerCase() !== "none"
      );
    const groups = [
      { type: "Child", values: toDescArray(record.child_imm_description) },
      { type: "Young", values: toDescArray(record.youngw_imm_description) },
      { type: "Pregnant", values: toDescArray(record.pregw_imm_description) },
      { type: "Elderly", values: toDescArray(record.elderly_imm_description) },
      { type: "Other", values: toImmArray(record.other_imm) },
    ];
    return groups.flatMap(({ type, values }) =>
      values.map((value, index) => ({
        ...record,
        key: `${record.id}-${type}-${index}`,
        imm_type: type,
        imm_description: value,
      }))
    );
  });

  // Function for handling the value in Cancer tab
  const handleAddCancerChange = (e) => {
    const { name, value } = e.target;
    setAddCancer((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Family Cancer Profile tab
  const handleAddFamilyCancerChange = (e) => {
    const { name, value } = e.target;
    setAddCancerFamily((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Hepatitis tab
  const handleAddHepatitisChange = (e) => {
    const { name, value } = e.target;
    setAddHepatitis((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Family Hepatitis tab
  const handleAddFamilyHepatitisChange = (e) => {
    const { name, value } = e.target;
    setAddHepatitisFamily((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in PulmonaryTB tab
  const handleAddPulmonaryTBChange = (e) => {
    const { name, value } = e.target;
    setAddPulmonaryTB((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Family PulmonaryTB tab
  const handleAddFamilyPulmonaryTBChange = (e) => {
    const { name, value } = e.target;
    setAddPulmonaryTBFamily((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in ExtrapulmonaryTB tab
  const handleAddPExtrapulmonaryTBChange = (e) => {
    const { name, value } = e.target;
    setAddExtrapulmonaryTB((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Family ExtrapulmonaryTB tab
  const handleAddFamilyExtrapulmonaryTBChange = (e) => {
    const { name, value } = e.target;
    setAddExtrapulmonaryTBFamily((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleObgyneChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === "menopause_age") {
      value = value.replace(/\D/g, "").slice(0, 2);
      e.target.value = value;
    }

    setAddObgyneHistory((prevState) => ({
      ...prevState,
      [name]: value,
        ...(name === "is_pregnancy_history_applicable" && value === "0"
        ? {
            preg_ind_hyp: "N",
            gravidity: "",
            parity: "",
            delivery_type: "",
            full_term_cnt: "",
            premature_cnt: "",
            abortion_cnt: "",
            living_children_cnt: "",
          }
        : {}),
    }));
  };

  // ===============================================
  /** API -- HYPERTENSION */
  async function addHypertensionSubmit() {
    setShowButton(true);
    if (validateHypertension(addHypertension, setError)) {
      const response = await createHypertension(addHypertension, id);
      if (response.status !== 200) {
        response.response.data.messages.error_messages.forEach((msg) => {
          toast.error(msg);
        });
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Hypertension");
        setAddHypertension({
          duration: "",
          usual_bp: "",
          highest_bp: "",
        });
        fetchHypertension();
      }
    }
    setShowButton(false);
  }
  async function updateHypertensionSubmit() {
    setShowButton(true);
    if (validateHypertension(addHypertension, setError)) {
      const response = await editHypertension(addHypertension, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsSelected("Hypertension");
        // reset button from "Save changes" -> "Submit"
        setIsEdit("");
        // reset form
        setAddHypertension({
          duration: "",
          usual_bp: "",
          highest_bp: "",
        });
        fetchHypertension();
      }
    } else {
    }
    setShowButton(false);
  }
  async function deleteTheHypertension() {
    const response = await deleteHypertension(addHypertension.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddHypertension({
        duration: "",
        usual_bp: "",
        highest_bp: "",
      });
      fetchHypertension();
      notifyHistoryChange();
    }
  }
  async function fetchHypertension() {
    setShowLoader(true);
    const response = await getHypertension({ patient_id: id.id });
    if (response.data) {
      setHypertensionDatas(response.data.data);
    } else {
      setHypertensionDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- DIABETES */
  async function addDiabetesSubmit() {
    setShowButton(true);
    if (validateDiabetes(addDiabetes, setError)) {
      const response = await createDiabetes(addDiabetes, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setAddDiabetes({
          id: "",
          duration: "",
          usual_fbs: "",
          usual_rbs: "",
          hba1c: "",
          cbg_range: "preprandial",
          complications: "",
        });
        fetchDiabetes();
      }
    }
    setShowButton(false);
  }
  async function updateDiabetes() {
    setShowButton(true);
    if (validateDiabetes(addDiabetes, setError)) {
      const response = await editDiabetes(addDiabetes, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddDiabetes({
          duration: "",
          usual_fbs: "",
          usual_rbs: "",
          hba1c: "",
          cbg_range: "preprandial",
          complications: "",
        });
        setIsEdit("");
        fetchDiabetes();
      }
    }
    setShowButton(false);
  }
  async function deleteDiabetes() {
    const response = await deleteDiabetesApi(addDiabetes.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddDiabetes({
        duration: "",
        usual_fbs: "",
        usual_rbs: "",
        hba1c: "",
        cbg_range: "preprandial",
        complications: "",
      });
      fetchDiabetes();
      notifyHistoryChange();
    }
  }
  async function fetchDiabetes() {
    setShowLoader(true);
    const response = await getDiabetes({ patient_id: id.id });
    if (response.data) {
      setDiabetesDatas(response.data.data);
    } else {
      setDiabetesDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- THYROID DISORDER */
  async function addThyroidDisorder() {
    setShowButton(true);
    if (validateThyroid(addThyroid, setError)) {
      const response = await createThyroid(addThyroid, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form fields
        setAddThyroid({
          id: "",
          type: "",
          duration: "",
          medication: "",
          rai: "",
          surgery: "",
          levothyroxine: "",
          histopathologic: "",
        });
        fetchThyroid();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateThyroid() {
    setShowButton(true);
    if (validateThyroid(addThyroid, setError)) {
      const response = await editThyroid(addThyroid, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        // reset form
        setAddThyroid({
          type: "",
          duration: "",
          medication: "",
          rai: "",
          surgery: "",
          levothyroxine: "",
          histopathologic: "",
        });
        setIsEdit("");
        fetchThyroid();
      }
    }
    setShowButton(false);
  }
  async function deleteThyroidDisorder() {
    const response = await deleteThyroid(addThyroid.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddThyroid({
        type: "",
        duration: "",
        medication: "",
        rai: "",
        surgery: "",
        levothyroxine: "",
        histopathologic: "",
      });
      fetchThyroid();
      notifyHistoryChange();
    }
  }
  async function fetchThyroid() {
    setShowLoader(true);
    const response = await getThyroid({ patient_id: id.id });
    if (response.data) {
      setThyroidDatas(response.data.data);
    } else {
      setThyroidDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- GDM */
  async function addGDMSubmit() {
    setShowButton(true);
    const response = await createGDM(addGDM, id);
    if (response.status !== 200) {
      toast.error(response.response.data.messages.error_messages[0]);
    } else {
      toast.success(response.data.message);
      // ✅ ADD THIS:
        notifyHistoryChange();
      fetchGDM();
    }
    setShowButton(false);
  }
  async function updateGDM() {
    setShowButton(true);
    const response = await editGDM(addGDM, id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      fetchGDM();
    }
    setShowButton(false);
  }
  async function deleteGDMSubmit() {
    setShowButton(true);
    const response = await deleteGDM(addGDM.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      fetchGDM();
      notifyHistoryChange();
    }
    setShowButton(false);
  }
  async function fetchGDM() {
    setShowLoader(true);
    const response = await getGDM({ patient_id: id.id });
    if (response.data) {
      setAddGDM(response.data.data[0]);
      setGdmEdit("gdm");
      setShowDeleteBtn(true);
    } else {
      setGdmEdit("edit");
      setAddGDM({
        id: "",
        aog: "",
        fasting: "",
        glucose_load_1h: "",
        glucose_load_2h: "",
        insulin_use: "",
        handout_link: "",
        gdm_profile_id: "",
      });
      setShowDeleteBtn(false);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- PRE-GDM */
  async function addPreGDMSubmit() {
    setShowButton(true);
    const response = await createPreGDM(addPreGDM, id);
    if (response.status !== 200) {
      toast.error(response.response.data.messages.error_messages[0]);
    } else {
      toast.success(response.data.message);
      // ✅ ADD THIS:
      notifyHistoryChange();
      fetchPreGDM();
    }
    setShowButton(false);
  }
  async function updatePreGDM() {
    setShowButton(true);
    const response = await editPreGDM(addPreGDM, id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      fetchPreGDM();
    }
    setShowButton(false);
  }
  async function deletePreGDMSubmit() {
    setShowButton(true);
    const response = await deletePreGDM(addPreGDM.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      fetchPreGDM();
      notifyHistoryChange();
    }
    setShowButton(false);
  }
  async function fetchPreGDM() {
    setShowLoader(true);
    const response = await getPreGDM({ patient_id: id.id });
    if (response.data) {
      setAddPreGDM(response.data.data[0]);
      setPreGdmEdit("preGDM");
      setShowDeletePreGDMBtn(true);
    } else {
      setPreGdmEdit("edit");
      setAddPreGDM({
        id: "",
        aog: "",
        fasting: "",
        glucose_load_1h: "",
        glucose_load_2h: "",
        insulin_use: "",
        handout_link: "",
        pre_gdm_profile_id: "",
      });
      setShowDeletePreGDMBtn(false);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- PITUITARY DISORDER */
  async function addPituitaryDisorder() {
    setShowButton(true);
    if (validatePituitary(addPituitary, setError)) {
      const response = await createPituitary(addPituitary, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setAddPituitary({
          id: "",
          name: "",
        });
        fetchPituitary();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updatePituitary() {
    setShowButton(true);
    if (validatePituitary(addPituitary, setError)) {
      const response = await editPituitary(addPituitary, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddPituitary({
          id: "",
          name: "",
        });
        setIsEdit("");
        fetchPituitary();
      }
    }
    setShowButton(false);
  }
  async function deletePituitaryDisorder() {
    const response = await deletePituitary(addPituitary.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddPituitary({ id: "", name: "" });
      fetchPituitary();
      notifyHistoryChange();
    }
  }
  async function fetchPituitary() {
    setShowLoader(true);
    const response = await getPituitary({ patient_id: id.id });
    if (response.data) {
      setPituitaryDatas(response.data.data);
    } else {
      setPituitaryDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- OTHER ENDOCRINE DISEASE */
  async function addEndocrineDisease() {
    setShowButton(true);
    if (validateEndocrine(addEndocrine, setError)) {
      const response = await createEndocrine(addEndocrine, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        // ✅ ADD THIS:
        notifyHistoryChange();
        setAddEndocrine({
          id: "",
          name: "",
        });
        toast.success(response.data.message);
        fetchEndocrine();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateEndocrine() {
    setShowButton(true);
    if (validateEndocrine(addEndocrine, setError)) {
      const response = await editEndocrine(addEndocrine, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        // reset form
        setAddEndocrine({
          id: "",
          name: "",
        });
        toast.success(response.data.data.message);
        setIsEdit("");
        fetchEndocrine();
      }
    } else {
    }
    setShowButton(false);
  }
  async function deleteEndocrineDisease() {
    const response = await deleteEndocrine(addEndocrine.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      // reset form
      setAddEndocrine({
        id: "",
        name: "",
      });
      setShowDelete(false);
      setIsEdit("");
      fetchEndocrine();
      notifyHistoryChange();
    }
  }
  async function fetchEndocrine() {
    setShowLoader(true);
    const response = await getEndocrine({ patient_id: id.id });
    if (response.data) {
      setEndocrineDatas(response.data.data);
    } else {
      setEndocrineDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- BRONCHIAL ASTHMA */
  async function addBronchialAsthma() {
    setShowButton(true);
    if (validateAsthma(addAsthma, setError)) {
      const response = await createAsthma(addAsthma, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setAddAsthma({
          id: "",
          duration: "",
          last_attack: "",
        });
        fetchAsthma();
      } else if (response.error) {
        response.error.data.messages.error_messages.forEach((msg) => {
          toast.error(msg);
        });
      }
    }
    setShowButton(false);
  }
  async function updateAsthma() {
    setShowButton(true);
    if (validateAsthma(addAsthma, setError)) {
      const response = await editAsthma(addAsthma, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddAsthma({ id: "", duration: "", last_attack: null });
        setIsEdit("");
        fetchAsthma();
      }
    }
    setShowButton(false);
  }
  async function deleteBronchialAsthma() {
    const response = await deleteAsthma(addAsthma.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddAsthma({ id: "", duration: "", last_attack: "" });
      fetchAsthma();
      notifyHistoryChange();
    }
  }
  async function fetchAsthma() {
    setShowLoader(true);
    const response = await getAsthma({ patient_id: id.id });
    if (response.data) {
      setAsthmaDatas(response.data.data);
    } else {
      setAsthmaDatas([]);
    }
    setShowLoader(false);
  }

  // ===============================================

  /** API -- OTHER ILLNESS */
  async function addOtherIllness() {
    setShowButton(true);
    if (validateIllness(addIllness, setError)) {
      const response = await createIllness(addIllness, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Other Illness");
        setAddIllness({ name: "" });
        fetchIllness();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateIllness() {
    setShowButton(true);
    if (validateIllness(addIllness, setError)) {
      const response = await editIllness(addIllness, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddIllness({ name: "" });
        setIsEdit("");
        fetchIllness();
      }
    }
    setShowButton(false);
  }
  async function deleteOtherIllness() {
    const response = await deleteIllness(addIllness.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddIllness({ name: "" });
      fetchIllness();
      notifyHistoryChange();
    }
  }
  async function fetchIllness() {
    setShowLoader(true);
    const response = await getIllness({ patient_id: id.id });
    if (response.data) {
      setIllnessDatas(response.data.data);
    } else {
      setIllnessDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- MAINTENANCE MEDICATION */
  async function addMaintenanceMedication() {
    setShowButton(true);
    if (validateMedication(addMedication, setError)) {
      const response = await createMedication(addMedication, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Maintenance Medication");
        setAddMedication({
          generic: "",
          brand: "",
          preparation: "",
          form: "",
          dosage: "",
          frequency: "",
          timing: "",
          duration: "",
          compliance: "",
        });
        fetchMedication();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateMedication() {
    setShowButton(true);
    if (validateMedication(addMedication, setError)) {
      const response = await editMedication(addMedication, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddMedication({
          generic: "",
          brand: "",
          preparation: "",
          form: "",
          dosage: "",
          frequency: "",
          timing: "",
          duration: "",
          compliance: "",
        });
        setIsEdit("");
        fetchMedication();
      }
    }
    setShowButton(false);
  }
  async function deleteMaintenanceMedication() {
    const response = await deleteMedication(addMedication.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddMedication({
        generic: "",
        brand: "",
        preparation: "",
        form: "",
        dosage: "",
        frequency: "",
        timing: "",
        duration: "",
        compliance: "",
      });
      fetchMedication();
      notifyHistoryChange();
    }
  }
  async function fetchMedication() {
    setShowLoader(true);
    const response = await getMedication({ patient_id: id.id });
    if (response.data) {
      setMedicationDatas(response.data.data);
    } else {
      setMedicationDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- FOOD ALLERGY */
  async function addFoodAllergy() {
    setShowButton(true);
    if (validateAllergy(addAllergy, setError)) {
      const response = await createAllergy(addAllergy, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setAddAllergy({ name: "", type: "" });
        fetchAllergy();
      }
    }
    setShowButton(false);
  }
  async function updateAllergy() {
    setShowButton(true);
    if (validateAllergy(addAllergy, setError)) {
      const response = await editAllergy(addAllergy, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddAllergy({ ...addAllergy, name: "", type: "" });
        setIsEdit("");
        fetchAllergy();
      }
    }
    setShowButton(false);
  }
  async function deleteFoodAllergy() {
    const response = await deleteAllergy(addAllergy.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddAllergy({ name: "", type: "" });
      fetchAllergy();
      notifyHistoryChange();
    }
  }
  async function fetchAllergy() {
    setShowLoader(true);
    const response = await getAllergy({ patient_id: id.id });
    if (response.data) {
      setAllergyData(response.data.data);
    } else {
      setAllergyData([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- SMOKING */
  async function addSmokingSubmit() {
    setShowButton(true);
    if (validateSmoking(addSmoking, setError)) {
      const response = await createSmoking(addSmoking, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Smoking");
        setAddSmoking({ duration: "", sticks_per_day: "" });
        fetchSmoking();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateSmoking() {
    setShowButton(true);
    if (validateSmoking(addSmoking, setError)) {
      const response = await editSmoking(addSmoking, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddSmoking({ duration: "", sticks_per_day: "" });
        setIsEdit("");
        fetchSmoking();
      }
    }
    setShowButton(false);
  }
  async function deleteSmokingSubmit() {
    const response = await deleteSmoking(addSmoking.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddSmoking({ ...addSmoking, duration: "", sticks_per_day: "" });
      fetchSmoking();
      notifyHistoryChange();
    }
  }
  async function fetchSmoking() {
    setShowLoader(true);
    const response = await getSmoking({ patient_id: id.id });
    if (response.data) {
      setSmokingDatas(response.data.data);
    } else {
      setSmokingDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- DRINKING */
  async function addDrinkingSubmit() {
    setShowButton(true);
    if (validateDrinking(addDrinking, setError)) {
      const response = await createDrinking(addDrinking, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Drinking");
        setAddDrinking({ frequency: "occasional", consumption: "light" });
        fetchDrinking();
      }
    } else {
      toast.error("Please enter all required fields.");
    }
    setShowButton(false);
  }
  async function updateDrinking() {
    setShowButton(true);
    if (validateDrinking(addDrinking, setError)) {
      const response = await editDrinking(addDrinking, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddDrinking({ frequency: "occasional", consumption: "light" });
        setIsEdit("");
        fetchDrinking();
      }
    }
    setShowButton(false);
  }
  async function deleteDrinkingSubmit() {
    const response = await deleteDrinking(addDrinking.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddDrinking({ frequency: "occasional", consumption: "light" });
      fetchDrinking();
      notifyHistoryChange();
    }
  }
  async function fetchDrinking() {
    setShowLoader(true);
    const response = await getDrinking({ patient_id: id.id });
    if (response.data) {
      setDrinkingDatas(response.data.data);
    } else {
      setDrinkingDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- ILLICIT DRUG USE */
  async function addDrugUse() {
    setShowButton(true);
    if (validateDrug(addDrug, setError)) {
      // if(addDrug.last_intake < year){
      const response = await createDrug(addDrug, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Illicit Drug Use");
        setAddDrug({ name: "", last_intake: "" });
        fetchDrug();
      }
    }
    setShowButton(false);
  }
  async function updateDrug() {
    setShowButton(true);
    if (validateDrug(addDrug, setError)) {
      const response = await editDrug(addDrug, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddDrug({ name: "", last_intake: "" });
        setIsEdit("");
        fetchDrug();
      }
    }
    setShowButton(false);
  }
  async function deleteDrugUse() {
    const response = await deleteDrug(addDrug.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddDrug({ name: "", last_intake: "" });
      fetchDrug();
      notifyHistoryChange();
    }
  }
  async function fetchDrug() {
    setShowLoader(true);
    const response = await getDrug({ patient_id: id.id });
    if (response.data) {
      setDrugDatas(response.data.data);
    } else {
      setDrugDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- HERBAL USE */
  async function addHerbalUse() {
    setShowButton(true);
    if (validateHerbal(addHerbal, setError)) {
      const response = await createHerbal(addHerbal, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Herbal Use");
        setAddHerbal({
          name: "",
          duration: "",
          last_intake: "",
        });
        fetchHerbal();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateHerbal() {
    setShowButton(true);
    if (validateHerbal(addHerbal, setError)) {
      const response = await editHerbal(addHerbal, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddHerbal({
          name: "",
          duration: "",
          last_intake: "",
        });
        setIsEdit("");
        fetchHerbal();
      }
    }
    setShowButton(false);
  }
  async function deleteHerbaluse() {
    const response = await deleteHerbal(addHerbal.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddHerbal({ name: "", duration: "", last_intake: "" });
      fetchHerbal();
      notifyHistoryChange();
    }
  }
  async function fetchHerbal() {
    setShowLoader(true);
    const response = await getHerbal({ patient_id: id.id });
    if (response.data) {
      setHerbalDatas(response.data.data);
    } else {
      setHerbalDatas([]);
    }
    setShowLoader(false);
  }

  // ===============================================

  /** API -- HEDEREDOFAMILIAL DISEASE */
  async function addHeredofamilialDisease() {
    setShowButton(true);
    if (validateHeredoFamilial(addHeredofamilial, setError)) {
      const selectedDiseases = Array.isArray(addHeredofamilial?.default_diseases)
        ? addHeredofamilial.default_diseases
        : [];
      const diseases = [];
      const descriptions = [];
      const pushEntry = (d, desc) => {
        diseases.push(d);
        descriptions.push(desc || "");
      };

      selectedDiseases.forEach((disease) => {
        if (disease === "Allergy" && Array.isArray(familyInputs.Allergy)) {
          familyInputs.Allergy.map((x) => x && x.trim())
            .filter(Boolean)
            .forEach((x) => pushEntry("Allergy", x));
        } else if (disease === "Cancer" && Array.isArray(familyInputs.Cancer)) {
          familyInputs.Cancer.map((x) => x && x.trim())
            .filter(Boolean)
            .forEach((x) => pushEntry("Cancer", x));
        } else if (disease === "Hepatitis" && familyInputs.Hepatitis?.trim()) {
          pushEntry("Hepatitis", familyInputs.Hepatitis.trim());
        } else if (
          disease === "Hypertension" &&
          familyInputs.Hypertension?.trim()
        ) {
          pushEntry("Hypertension", familyInputs.Hypertension.trim());
        } else if (
          disease === "Tuberculosis" &&
          familyInputs.Tuberculosis?.trim()
        ) {
          pushEntry("Tuberculosis", familyInputs.Tuberculosis.trim());
        } else if (
          disease === "Extrapulmonary Tuberculosis" &&
          familyInputs["Extrapulmonary Tuberculosis"]?.trim()
        ) {
          pushEntry(
            "Extrapulmonary Tuberculosis",
            familyInputs["Extrapulmonary Tuberculosis"].trim()
          );
        } else {
          pushEntry(disease, "");
        }
      });

      (addHeredofamilial?.others || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
        .forEach((name) => pushEntry(name, name));

      const response = await createHeredofamilialDetails(
        { diseases, descriptions },
        id
      );
      if (response.data) {
        toast.success(response.data.message || "Family Past Medical History saved");
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Family Past Medical History");
        setAddHeredofamilial({ id: "", default_diseases: [], others: "" });
        setFamilyInputs({
          Allergy: [""],
          Cancer: [""],
          Hepatitis: "",
          Hypertension: "",
          Tuberculosis: "",
          "Extrapulmonary Tuberculosis": "",
        });
        fetchHeredofamilial();
      } else if (response.error) {
        toast.error(response.error);
      }
    } else {
      toast.error("Please fill in all required fields.");
    }
    setShowButton(false);
  }
  async function deleteHeredofamilialSubmit() {
    setShowButton(true);
    if (validateHeredoFamilial(addHeredofamilial, setError)) {
      const response = await deleteHeredofamilial(id);
      if (response.data) {
        toast.success(response.data.message);
        setAddHeredofamilial({ ...addDrug, name: "", others: "" });
        fetchHeredofamilial();
        notifyHistoryChange();
      } else if (response.error) {
        toast.error(response.error);
      }
    }
    setShowButton(false);
  }
  async function fetchHeredofamilial() {
    setShowLoader(true);
    const response = await getHeredofamilial({ patient_id: id.id });
    if (response.data) {
      const rows = [];
      const parseName = (name) => {
        const str = (name || "").trim();
        if (!str) return null;
        const colonIdx = str.indexOf(":");
        if (colonIdx > -1) {
          const disease = str.substring(0, colonIdx).trim();
          const description = str.substring(colonIdx + 1).trim();
          return { disease, description };
        }
        return { disease: str, description: "" };
      };
      if (Array.isArray(response.data.data) && response.data.data.length) {
        response.data.data.forEach((rec) => {
          if (rec) {
            if (rec.disease || rec.description) {
              rows.push({
                disease: rec.disease || "",
                description: rec.description || "",
                added_on: rec.added_on || "",
              });
            } else if (rec.name) {
              const parsed = parseName(rec.name);
              if (parsed) {
                rows.push({
                  disease: parsed.disease,
                  description: parsed.description,
                  added_on: rec.added_on || "",
                });
              }
            }
          }
        });
      } else {
        const rawNames = response.data.names || [];
        rawNames.forEach((name) => {
          const parsed = parseName(name);
          if (parsed) rows.push({ ...parsed, added_on: "" });
        });
        const rawOthers = response.data.others || "";
        rawOthers
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean)
          .forEach((item) => rows.push({ disease: item, description: "", added_on: "" }));
      }
      setHeredofamilialDatas(rows);
      setShowHeredofamilialDeleteBtn(rows.length > 0);
      setAddHeredofamilial({ id: "", default_diseases: [], others: "" });
      setFamilyInputs({
        Allergy: [""],
        Cancer: [""],
        Hepatitis: "",
        Hypertension: "",
        Tuberculosis: "",
        "Extrapulmonary Tuberculosis": "",
      });
    } else {
      setHeredofamilialDatas([]);
      setShowHeredofamilialDeleteBtn(false);
      setAddHeredofamilial({ id: "", default_diseases: [], others: "" });
      setFamilyInputs({
        Allergy: [""],
        Cancer: [""],
        Hepatitis: "",
        Hypertension: "",
        Tuberculosis: "",
        "Extrapulmonary Tuberculosis": "",
      });
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- LAST HOSPITALIZATION */
  async function addLastHospitalization() {
    setShowButton(true);
    if (validateHospitalization(addHospitalization, setError)) {
      const response = await createLastHospitalization(addHospitalization, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success("Hospitalization Profile Successfully Added!");
        // ✅ ADD THIS:
        notifyHistoryChange();
        setIsSelected("Surgeries");
        setAddHospitalization({
          name: "",
          admitted_on: "",
          reason: "",
        });
        fetchLastHospitalization();
      }
    }
    setShowButton(false);
  }
  async function updateLastHospitalization() {
    setShowButton(true);
    if (validateHospitalization(addHospitalization, setError)) {
      const response = await editLastHospitalization(addHospitalization, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success("Hospitalization Profile Successful Updated!");
        setAddHospitalization({
          id: "",
          name: "",
          admitted_on: "",
          reason: "",
        });
        setIsEdit("");
        fetchLastHospitalization();
      }
    }
    setShowButton(false);
  }
  async function deleteLastHospitalization() {
    const response = await deleteHospitalization(addHospitalization.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success("Hospitalization Profile  Deleted Successfully!");
      setShowDelete(false);
      setIsEdit("");
      setAddHospitalization({
        id: "",
        name: "",
        admitted_on: "",
        reason: "",
      });
      fetchLastHospitalization();
      notifyHistoryChange();
    }
  }

  async function fetchLastHospitalization() {
    setShowLoader(true);
    const response = await getHospitalization({ patient_id: id.id });
    if (response.data) {
      setLastHospitalizationDatas(response.data.data);
    } else {
      setLastHospitalizationDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- VACCINATION */
  async function addVaxProfile() {
    setShowButton(true);
    if (validateVaxProfile(addVax, setError)) {
      const response = await createImmunization(addVax, id);
      if (response.data) {
        toast.success(response.data.message);
        notifyHistoryChange();
        setAddVax({
          id: "",
          patient_id: "",
          assessment_id: "",
          child_imm_code: [],
          youngw_imm_code: [],
          pregw_imm_code: [],
          elderly_imm_code: [],
          other_imm: [],
        });
        fetchVaxProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateVaxProfile() {
    setShowButton(true);
    if (validateVaxProfile(addVax, setError)) {
      const response = await editImmunization(addVax, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        setAddVax({
          id: "",
          patient_id: "",
          assessment_id: "",
          child_imm_code: [],
          youngw_imm_code: [],
          pregw_imm_code: [],
          elderly_imm_code: [],
          other_imm: [],
        });
        fetchVaxProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteVaxProfileSubmit() {
    const response = await deleteImmunization(addVax.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      setAddVax({
        id: "",
        patient_id: "",
        assessment_id: "",
        child_imm_code: [],
        youngw_imm_code: [],
        pregw_imm_code: [],
        elderly_imm_code: [],
        other_imm: [],
      });
      fetchVaxProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }
  async function fetchVaxProfile() {
    setShowLoader(true);
    const response = await getImmunization({ patient_id: id.id });
    if (response.data) {
      setVaxShot(response.data.data);
    } else {
      setVaxShot([]);
    }
    setShowLoader(false);
  }
  // Options of vaccination shots
  async function fetchVaccinationShots() {
    const response = await getVaccinationShots();
    if (response.data) {
      var _parsed = response.data.data.map((vax) => {
        return {
          label: vax.vax,
          value: vax.id,
        };
      });
      setVaccinationShots(_parsed);
    } else {
      setVaccinationShots([]);
    }
  }

  async function fetchImmunizationCodes() {
    const childRes = await getYakapImmunization("child");
    if (childRes.data) {
      setChildImmOptions(
        childRes.data.data.map((item) => ({
          label: item.description,
          value: item.id,
        }))
      );
    } else {
      setChildImmOptions([]);
    }

    const youngRes = await getYakapImmunization("youngw");
    if (youngRes.data) {
      setYoungImmOptions(
        youngRes.data.data.map((item) => ({
          label: item.description,
          value: item.id,
        }))
      );
    } else {
      setYoungImmOptions([]);
    }

    const pregRes = await getYakapImmunization("pregw");
    if (pregRes.data) {
      setPregImmOptions(
        pregRes.data.data.map((item) => ({
          label: item.description,
          value: item.id,
        }))
      );
    } else {
      setPregImmOptions([]);
    }

    const elderlyRes = await getYakapImmunization("elderly");
    if (elderlyRes.data) {
      setElderlyImmOptions(
        elderlyRes.data.data.map((item) => ({
          label: item.description,
          value: item.id,
        }))
      );
    } else {
      setElderlyImmOptions([]);
    }
  }

  //Cancer Profile
  async function addCancerProfile() {
    setShowButton(true);
    if (validateCancerProfile(addCancer, setError)) {
      const response = await createCancerProfile(addCancer, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddCancer({
          id: "",
          organ: "",
        });

        fetchCancerProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateCancerProfile() {
    setShowButton(true);
    if (validateCancerProfile(addCancer, setError)) {
      const response = await editCancerProfile(addCancer, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddCancer({
          id: "",
          organ: "",
        });
        fetchCancerProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteCancer() {
    const response = await deleteCancerProfile(addCancer.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddCancer({
        id: "",
        organ: "",
      });
      fetchCancerProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchCancerProfile() {
    setShowLoader(true);
    const response = await getCancerProfile({ patient_id: id.id });
    if (response.data) {
      var _parsed = response.data.data;
      setCancerDatas(_parsed);
    } else {
      setCancerDatas([]);
    }
    setShowLoader(false);
  }

  //Family Cancer Profile
  async function addCancerFamilyProfile() {
    setShowButton(true);
    if (validateCancerProfile(addCancerFamily, setError)) {
      const response = await createCancerFamilyProfile(addCancerFamily, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddCancerFamily({
          id: "",
          organ: "",
        });

        fetchCancerFamilyProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateCancerFamilyProfile() {
    setShowButton(true);
    if (validateCancerProfile(addCancerFamily, setError)) {
      const response = await editCancerFamilyProfile(addCancerFamily, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddCancerFamily({
          id: "",
          organ: "",
        });
        fetchCancerFamilyProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteFamilyCancer() {
    const response = await deleteCancerFamilyProfile(addCancerFamily.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddCancerFamily({
        id: "",
        organ: "",
      });
      fetchCancerFamilyProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchCancerFamilyProfile() {
    setShowLoader(true);
    const response = await getCancerFamilyProfile({ patient_id: id.id });
    if (response.data) {
      var _parsed = response.data.data;
      setCancerFamilyDatas(_parsed);
    } else {
      setCancerFamilyDatas([]);
    }
    setShowLoader(false);
  }

  //Hepatitis Profile
  async function addHepatitisProfile() {
    setShowButton(true);
    if (validateHepatitisProfile(addHepatitis, setError)) {
      const response = await createHepatitisProfile(addHepatitis, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddHepatitis({
          id: "",
          type: "",
        });

        fetchHepatitisProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateHepatitisProfile() {
    setShowButton(true);
    if (validateHepatitisProfile(addHepatitis, setError)) {
      const response = await editHepatitisProfile(addHepatitis, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddHepatitis({
          id: "",
          type: "",
        });
        fetchHepatitisProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteHepatitis() {
    const response = await deleteHepatitisProfile(addHepatitis.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddHepatitis({
        id: "",
        type: "",
      });
      fetchHepatitisProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchHepatitisProfile() {
    setShowLoader(true);
    const response = await getHepatitisProfile({ patient_id: id.id });
    if (response.data) {
      var _parsed = response.data.data;
      setHepatitisDatas(_parsed);
    } else {
      setHepatitisDatas([]);
    }
    setShowLoader(false);
  }

  //Hepatitis Family Profile
  async function addHepatitisFamilyProfile() {
    setShowButton(true);
    if (validateHepatitisProfile(addHepatitisFamily, setError)) {
      const response = await createHepatitisFamilyProfile(
        addHepatitisFamily,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddHepatitisFamily({
          id: "",
          type: "",
        });

        fetchHepatitisFamilyProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateHepatitisFamilyProfile() {
    setShowButton(true);
    if (validateHepatitisProfile(addHepatitisFamily, setError)) {
      const response = await editHepatitisFamilyProfile(addHepatitisFamily, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddHepatitisFamily({
          id: "",
          type: "",
        });
        fetchHepatitisFamilyProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteFamilyHepatitis() {
    const response = await deleteHepatitisFamilyProfile(addHepatitisFamily.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddHepatitisFamily({
        id: "",
        type: "",
      });
      fetchHepatitisFamilyProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchHepatitisFamilyProfile() {
    setShowLoader(true);
    const response = await getHepatitisFamilyProfile({ patient_id: id.id });
    if (response.data) {
      var _parsed = response.data.data;
      setHepatitisFamilyDatas(_parsed);
    } else {
      setHepatitisFamilyDatas([]);
    }
    setShowLoader(false);
  }

  //PulmonaryTB Profile
  async function addPulmonaryTBProfile() {
    setShowButton(true);
    if (validateTBProfile(addPulmonaryTB, setError)) {
      const response = await createPulmonaryTBProfile(addPulmonaryTB, id);
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddPulmonaryTB({
          id: "",
          category: "",
        });

        fetchPulmonaryTBProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updatePulmonaryTBProfile() {
    setShowButton(true);
    if (validateTBProfile(addPulmonaryTB, setError)) {
      const response = await editPulmonaryTBProfile(addPulmonaryTB, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddPulmonaryTB({
          id: "",
          category: "",
        });
        fetchPulmonaryTBProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deletePulmonaryTB() {
    const response = await deletePulmonaryTBProfile(addPulmonaryTB.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddPulmonaryTB({
        id: "",
        category: "",
      });
      fetchPulmonaryTBProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchPulmonaryTBProfile() {
    setShowLoader(true);
    const response = await getPulmonaryTBProfile({
      patient_id: id.id,
      is_extra: "0",
    });
    if (response.data) {
      var _parsed = response.data.data;
      setPulmonaryTBDatas(_parsed);
    } else {
      setPulmonaryTBDatas([]);
    }
    setShowLoader(false);
  }

  //PulmonaryTB Family Profile
  async function addPulmonaryTBFamilyProfile() {
    setShowButton(true);
    if (validateTBProfile(addPulmonaryTBFamily, setError)) {
      const response = await createPulmonaryTBFamilyProfile(
        addPulmonaryTBFamily,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddPulmonaryTBFamily({
          id: "",
          category: "",
        });

        fetchPulmonaryTBFamilyProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updatePulmonaryTBFamilyProfile() {
    setShowButton(true);
    if (validateTBProfile(addPulmonaryTBFamily, setError)) {
      const response = await editPulmonaryTBFamilyProfile(
        addPulmonaryTBFamily,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddPulmonaryTBFamily({
          id: "",
          category: "",
        });
        fetchPulmonaryTBFamilyProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteFamilyPulmonaryTB() {
    const response = await deletePulmonaryTBFamilyProfile(
      addPulmonaryTBFamily.id
    );
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddPulmonaryTBFamily({
        id: "",
        category: "",
      });
      fetchPulmonaryTBFamilyProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchPulmonaryTBFamilyProfile() {
    setShowLoader(true);
    const response = await getPulmonaryTBFamilyProfile({
      patient_id: id.id,
      is_extra: "0",
    });
    if (response.data) {
      var _parsed = response.data.data;
      setPulmonaryTBFamilyDatas(_parsed);
    } else {
      setPulmonaryTBFamilyDatas([]);
    }
    setShowLoader(false);
  }

  //ExtrapulmonaryTB Profile
  async function addExtrapulmonaryTBProfile() {
    setShowButton(true);
    if (validateTBProfile(addExtrapulmonaryTB, setError)) {
      const response = await createExtrapulmonaryTBProfile(
        addExtrapulmonaryTB,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddExtrapulmonaryTB({
          id: "",
          category: "",
        });

        fetchExtrapulmonaryTBProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateExtrapulmonaryTBProfile() {
    setShowButton(true);
    if (validateTBProfile(addExtrapulmonaryTB, setError)) {
      const response = await editExtrapulmonaryTBProfile(
        addExtrapulmonaryTB,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddExtrapulmonaryTB({
          id: "",
          category: "",
        });
        fetchExtrapulmonaryTBProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteExtrapulmonaryTB() {
    const response = await deleteExtrapulmonaryTBProfile(
      addExtrapulmonaryTB.id
    );
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddExtrapulmonaryTB({
        id: "",
        category: "",
      });
      fetchExtrapulmonaryTBProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchExtrapulmonaryTBProfile() {
    setShowLoader(true);
    const response = await getExtrapulmonaryTBProfile({
      patient_id: id.id,
      is_extra: "1",
    });
    if (response.data) {
      var _parsed = response.data.data;
      setExtrapulmonaryTBDatas(_parsed);
    } else {
      setExtrapulmonaryTBDatas([]);
    }
    setShowLoader(false);
  }

  async function addExtrapulmonaryTBFamilyProfile() {
    setShowButton(true);
    if (validateTBProfile(addExtrapulmonaryTBFamily, setError)) {
      const response = await createExtrapulmonaryTBFamilyProfile(
        addExtrapulmonaryTBFamily,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        // ✅ ADD THIS:
        notifyHistoryChange();
        // reset form
        setAddExtrapulmonaryTBFamily({
          id: "",
          category: "",
        });

        fetchExtrapulmonaryTBFamilyProfile();
      } else if (response.error) {
      }
    }
    setShowButton(false);
  }
  async function updateExtrapulmonaryTBFamilyProfile() {
    setShowButton(true);
    if (validateTBProfile(addExtrapulmonaryTBFamily, setError)) {
      const response = await editExtrapulmonaryTBFamilyProfile(
        addExtrapulmonaryTBFamily,
        id
      );
      if (response.data) {
        toast.success(response.data.message);
        setIsEdit("");
        // reset form
        setAddExtrapulmonaryTBFamily({
          id: "",
          category: "",
        });
        fetchExtrapulmonaryTBFamilyProfile();
      } else if (response.error) {
      }
      setShowButton(false);
    }
  }
  async function deleteFamilyExtrapulmonaryTB() {
    const response = await deleteExtrapulmonaryTBFamilyProfile(
      addExtrapulmonaryTBFamily.id
    );
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddExtrapulmonaryTBFamily({
        id: "",
        category: "",
      });
      fetchExtrapulmonaryTBFamilyProfile();
      notifyHistoryChange();
    } else if (response.error) {
    }
  }

  async function fetchExtrapulmonaryTBFamilyProfile() {
    setShowLoader(true);
    const response = await getExtrapulmonaryTBFamilyProfile({
      patient_id: id.id,
      is_extra: "1",
    });
    if (response.data) {
      var _parsed = response.data.data;
      setExtrapulmonaryTBFamilyDatas(_parsed);
    } else {
      setExtrapulmonaryTBFamilyDatas([]);
    }
    setShowLoader(false);
  }

  async function handleAddObgyneHistory() {
    if (showLoader || obgyneDatas.length > 0) return;

    setShowButton(true);
    const response = await createAddObgyneHistory(addObgyneHistory, id);
    if (response.data) {
      toast.success(response.data.message);
      // ✅ ADD THIS:
      notifyHistoryChange();
      // reset form
      setAddObgyneHistory(INITIAL_OBGYNE_HISTORY);
      setIsEdit("");

      fetchObgyneHistory();
    } else if (response.error) {
    }
    setShowButton(false);
  }

  async function handleEditObgyneHistory() {
    if (showLoader || !addObgyneHistory.id) return;

    setShowButton(true);
    const response = await editObgyneHistory(addObgyneHistory, id);
    if (response.data) {
      toast.success(response.data.message);
      // reset form
      setAddObgyneHistory(INITIAL_OBGYNE_HISTORY);
      setIsEdit("");

      fetchObgyneHistory();
    } else if (response.error) {
    }
    setShowButton(false);
  }

  async function handleDeleteObgyneHistory() {
    setShowButton(true);
    const response = await deleteObgyneHistory(addObgyneHistory.id);
    if (response.data) {
      toast.success(response.data.message);
      setShowDelete(false);
      // reset form
      setAddObgyneHistory(INITIAL_OBGYNE_HISTORY);

      fetchObgyneHistory();
    } else if (response.error) {
    }
    setShowButton(false);
  }

  async function fetchObgyneHistory() {
    setShowLoader(true);
    const response = await getObgyneHistory({
      patient_id: id.id,
    });
    if (response.data) {
      var _parsed = response.data.data.map((vax) => {
        return {
          ...vax,
          has_family_planning: vax.has_family_planning,
          formatted_has_family_planning:
            vax.has_family_planning === "1" ? "yes" : "no",
          formatted_preg_ind_hyp: vax.preg_ind_hyp === "Y" ? "yes" : "no",
          formatted_is_menopause: vax.is_menopause === "Y" ? "yes" : "no",
          formatted_is_pregnancy_history_applicable:
            vax.is_pregnancy_history_applicable === "1" ? "yes" : "no",
          formatted_delivery_type:
            deliveryTypeOptions.find(
              (option) => option.value === vax.delivery_type
            )?.label || vax.delivery_type,
        };
      });
      setObgyneDatas(_parsed);
      if (_parsed.length > 0 && !isMalePatient) {
        setAddObgyneHistory({ ...INITIAL_OBGYNE_HISTORY, ..._parsed[0] });
        setIsEdit("edit");
      } else {
        setAddObgyneHistory(INITIAL_OBGYNE_HISTORY);
        setIsEdit("");
      }
    } else {
      setObgyneDatas([]);
      setAddObgyneHistory(INITIAL_OBGYNE_HISTORY);
      setIsEdit("");
    }
    setShowLoader(false);
  }

  // ===============================================

  const cbgRangeOptions = [
    {
      key: "1",
      value: "preprandial",
      label: "Preprandial",
    },
    {
      key: "2",
      value: "postpandrial",
      label: "Postpandrial",
    },
  ];

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const handleActionChange = (e, row, type, form) => {
    if (type === "edit") {
      if (form === "hospitalization") {
        setAddHospitalization(row);
        setIsEdit(type);
      } else if (form === "allergy") {
        setAddAllergy(row);
        setIsEdit(type);
      } else if (form === "asthma") {
        setAddAsthma(row);
        setIsEdit(type);
      } else if (form === "diabetes") {
        setAddDiabetes(row);
        setIsEdit(type);
      } else if (form === "medication") {
        setAddMedication(row);
        setIsEdit(type);
      } else if (form === "hypertension") {
        setAddHypertension(row);
        setIsEdit(type);
      } else if (form === "herbal") {
        setAddHerbal(row);
        setIsEdit(type);
      } else if (form === "thyroid") {
        setAddThyroid(row);
        setIsEdit(type);
      } else if (form === "pituitary") {
        setAddPituitary(row);
        setIsEdit(type);
      } else if (form === "endocrine") {
        setAddEndocrine(row);
        setIsEdit(type);
      } else if (form === "illness") {
        setAddIllness(row);
        setIsEdit(type);
      } else if (form === "smoking") {
        setAddSmoking(row);
        setIsEdit(type);
      } else if (form === "drinking") {
        // var _consumption = "";
        // switch (row.consumption) {
        //   case "heavy":
        //     _consumption = "1";
        //     break;
        //   case "light":
        //     _consumption = "2";
        //     break;
        //   case "moderate":
        //     _consumption = "3";
        //     break;
        //   default:
        //     return;
        // }
        // setAddDrinking({
        //   ...row,
        //   consumption: _consumption,
        // });
        setAddDrinking(row);
        setIsEdit(type);
      } else if (form === "drug") {
        setAddDrug(row);
        setIsEdit(type);
      } else if (form === "vaccination") {
        setAddVax({
          ...row,
          child_imm_code: toImmArray(row.child_imm_code),
          youngw_imm_code: toImmArray(row.youngw_imm_code),
          pregw_imm_code: toImmArray(row.pregw_imm_code),
          elderly_imm_code: toImmArray(row.elderly_imm_code),
          other_imm: toImmArray(row.other_imm),
        });
        setIsEdit(type);
      } else if (form === "heredofamilial") {
        var defaultDiseases = [
          // "asthma",
          // "cancer",
          // "diabetes",
          // "heart_disease",
          // "hypertension",
          // "stroke",
          // "others",
          "Allergy",
          "Asthma",
          "Cancer",
          "Cerebrovascular Disease",
          "Coronary Artery Disease",
          "Diabetes Mellitus",
          "Epilepsy/Seizure Disorder",
          "Extrapulmonary Tuberculosis",
          "Pulmonary Tuberculosis",
          "Hepatitis",
          "Hyerlipidemia",
          "Hypertension",
          "Peptic Ulcer",
          "Pneumonia",
          "Thyroid Disease",
          "Tuberculosis",
          "Urinary Tract Infection",
          "Mental Illness",
        ];
        if (defaultDiseases.includes(row.name)) {
          setAddHeredofamilial({
            default_diseases: [row.name],
          });
        } else {
          setAddHeredofamilial({
            others: row.name,
          });
        }
        setIsEdit(type);
      } else if (form === "vaccination") {
        setAddVax(row);
        setIsEdit(type);
      } else if (form === "cancer") {
        setAddCancer(row);
        setIsEdit(type);
      } else if (form === "family_cancer_profile") {
        setAddCancerFamily(row);
        setIsEdit(type);
      } else if (form === "hepatitis") {
        setAddHepatitis(row);
        setIsEdit(type);
      } else if (form === "family_hepatitis_profile") {
        setAddHepatitisFamily(row);
        setIsEdit(type);
      } else if (form === "pulmonary_tb") {
        setAddPulmonaryTB(row);
        setIsEdit(type);
      } else if (form === "family_pulmonary_tb") {
        setAddPulmonaryTBFamily(row);
        setIsEdit(type);
      } else if (form === "extrapulmonary_tb") {
        setAddExtrapulmonaryTB(row);
        setIsEdit(type);
      } else if (form === "family_extrapulmonary_tb") {
        setAddExtrapulmonaryTBFamily(row);
        setIsEdit(type);
      } else if (form === "obgyne") {
        setAddObgyneHistory({ ...INITIAL_OBGYNE_HISTORY, ...row });
        setIsEdit(type);
      }
    } else if (type === "delete") {
      if (form === "hospitalization") {
        setAddHospitalization(row);
        setShowDelete(true);
      } else if (form === "allergy") {
        setAddAllergy(row);
        setShowDelete(true);
      } else if (form === "asthma") {
        setAddAsthma(row);
        setShowDelete(true);
      } else if (form === "diabetes") {
        setAddDiabetes(row);
        setShowDelete(true);
      } else if (form === "medication") {
        setAddMedication(row);
        setShowDelete(true);
      } else if (form === "hypertension") {
        setAddHypertension(row);
        setShowDelete(true);
      } else if (form === "herbal") {
        setAddHerbal(row);
        setShowDelete(true);
      } else if (form === "thyroid") {
        setAddThyroid(row);
        setShowDelete(true);
      } else if (form === "pituitary") {
        setAddPituitary(row);
        setShowDelete(true);
      } else if (form === "endocrine") {
        setAddEndocrine(row);
        setShowDelete(true);
      } else if (form === "illness") {
        setAddIllness(row);
        setShowDelete(true);
      } else if (form === "smoking") {
        setAddSmoking(row);
        setShowDelete(true);
      } else if (form === "drinking") {
        setAddDrinking(row);
        setShowDelete(true);
      } else if (form === "drug") {
        setAddDrug(row);
        setShowDelete(true);
      } else if (form === "vaccination") {
        setAddVax(row);
        setShowDelete(true);
      } else if (form === "cancer") {
        setAddCancer(row);
        setShowDelete(true);
      } else if (form === "family_cancer_profile") {
        setAddCancerFamily(row);
        setShowDelete(true);
      } else if (form === "hepatitis") {
        setAddHepatitis(row);
        setShowDelete(true);
      } else if (form === "family_hepatitis_profile") {
        setAddHepatitisFamily(row);
        setShowDelete(true);
      } else if (form === "pulmonary_tb") {
        setAddPulmonaryTB(row);
        setShowDelete(true);
      } else if (form === "family_pulmonary_tb") {
        setAddPulmonaryTBFamily(row);
        setShowDelete(true);
      } else if (form === "extrapulmonary_tb") {
        setAddExtrapulmonaryTB(row);
        setShowDelete(true);
      } else if (form === "family_extrapulmonary_tb") {
        setAddExtrapulmonaryTBFamily(row);
        setShowDelete(true);
      } else if (form === "obgyne") {
        setAddObgyneHistory({ ...INITIAL_OBGYNE_HISTORY, ...row });
        setShowDelete(true);
      }
    }
  };
  function ActionBtn(row, form) {
    return (
      <Row className="center">
        {(form !== "obgyne" || !isMalePatient) && (
          <Col>
            <BtnSave
              id={"edit"}
              name={"edit"}
              label={"Edit"}
              size={"sm"}
              onClick={(e) => handleActionChange(e, row.row, "edit", form)}
            />
          </Col>
        )}
        {role === "director" || role === "pcp" || role === "specialist" && (
          <Col>
            <BtnDelete
              label={"Delete"}
              size={"sm"}
              onClick={(e) => handleActionChange(e, row.row, "delete", form)}
            />
          </Col>
        )}
      </Row>
    );
  }

  React.useEffect(() => {
    if (isSelected === "Hypertension") fetchHypertension();
    else if (isSelected === "Diabetes") fetchDiabetes();
    else if (isSelected === "Thyroid Disorders") fetchThyroid();
    else if (isSelected === "GDM") fetchGDM();
    else if (isSelected === "Pre-GDM") fetchPreGDM();
    else if (isSelected === "Pituitary Disorders") fetchPituitary();
    else if (isSelected === "Other Endocrine Diseases") fetchEndocrine();
    else if (isSelected === "Bronchial Asthma") fetchAsthma();
    else if (isSelected === "Other Illness") fetchIllness();
    else if (isSelected === "Maintenance Medication") fetchMedication();
    else if (isSelected === "Food/Drug Allergy") fetchAllergy();
    else if (isSelected === "Smoking") fetchSmoking();
    else if (isSelected === "Drinking") fetchDrinking();
    else if (isSelected === "Illicit Drug Use") fetchDrug();
    else if (isSelected === "Herbal Use") fetchHerbal();
    else if (isSelected === "Family Past Medical History")
      fetchHeredofamilial();
    else if (isSelected === "Surgeries") fetchLastHospitalization();
    else if (isSelected === "Vaccination") {
      fetchVaxProfile();
      fetchVaccinationShots();
      fetchImmunizationCodes();
    } else if (isSelected === "Cancer") {
      fetchCancerProfile();
    } else if (isSelected === "Family Cancer Profile") {
      fetchCancerFamilyProfile();
    } else if (isSelected === "Hepatitis") {
      fetchHepatitisProfile();
    } else if (isSelected === "Family Hepatitis Profile") {
      fetchHepatitisFamilyProfile();
    } else if (isSelected === "Pulmonary Tuberculosis") {
      fetchPulmonaryTBProfile();
    } else if (isSelected === "Family Pulmonary Tuberculosis Profile") {
      fetchPulmonaryTBFamilyProfile();
    } else if (isSelected === "Extrapulmonary Tuberculosis") {
      fetchExtrapulmonaryTBProfile();
    } else if (isSelected === "Family Extrapulmonary Tuberculosis Profile") {
      fetchExtrapulmonaryTBFamilyProfile();
    } else if (isSelected === "OB-Gyne History") {
      fetchObgyneHistory();
    }
    setAddHospitalization({});
    setAddAllergy({
      name: "",
      type: "drug",
    });
    setAddAsthma({});
    setAddDiabetes({
      duration: "",
      usual_fbs: "",
      usual_rbs: "",
      hba1c: "",
      cbg_range: "preprandial",
      complications: "",
    });
    setAddMedication({});
    setAddHypertension({});
    setAddHerbal({});
    setAddThyroid({});
    setAddPituitary({});
    setAddEndocrine({});
    setAddIllness({});
    setAddSmoking({});
    setAddDrinking({
      frequency: "occasional",
      consumption: "light",
    });
    setAddDrug({});
    setAddVax({});
    setAddHeredofamilial({});
    setAddVax({});
    setAddCancer({});
    setAddCancerFamily({});
    setAddHepatitis({});
    setAddHepatitisFamily({});
    setAddPulmonaryTB({});
    setAddPulmonaryTBFamily({});
    setAddExtrapulmonaryTB({});
    setAddExtrapulmonaryTBFamily({});
    setAddObgyneHistory(INITIAL_OBGYNE_HISTORY);
    setIsEdit(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected]);

  return (
    <div className={!isMedicalHistory ? "" : "card-with-table p-3"}>
      {/* <ToastContainer /> */}
      <div className="row">
        {isMedicalHistory && (
          <div className="col p-3 me-2 pt-2">
            <>
              <div className="col mb-4 pt-1">
                <div className="row">
                  <div className="col">
                    <h5 className="font-bold">MEDICAL HISTORY</h5>
                  </div>
                  <div className="col-3">
                    <BtnAdd
                      label={"+ Add New Entry"}
                      onClick={() => {
                        setSelectedItem(0);
                        setIsSelected("Past Medical History");
                        setIsMedicalHistory(false);
                      }}
                    />
                  </div>
                </div>
              </div>
              <MedicalHistorySummary
                isVisible
                patientSex={patientSex}
                setSelectedItem={setSelectedItem}
                setIsMedicalHistory={() => setIsMedicalHistory()}
                setIsSelected={setIsSelected}
              />
            </>
          </div>
        )}
        {!isMedicalHistory && (
          <div className="col-2 p-3 header-btn manager-container pt-2 show-summary-container">
            <div className="row mt-1 pt-1">
              <div className="col">
                <BtnAdd
                  label={"Show Summary"}
                  onClick={() => setIsMedicalHistory(true)}
                />
              </div>
            </div>
            <div className="row mt-1.s">
              <List className="list-tab-cont">
                {listTabs.map((data, index) => {
                  return (
                    <List.Item
                      key={index}
                      className={`p-1 px-2 m-1 fs-small text-start list-item ${
                        selectedItem === index ? "selected" : ""
                      } ${
                        data.label === "OB-Gyne History" && isMalePatient
                          ? "disabled"
                          : ""
                      }`}
                      aria-disabled={
                        data.label === "OB-Gyne History" && isMalePatient
                      }
                      style={
                        data.label === "OB-Gyne History" && isMalePatient
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : undefined
                      }
                      onClick={(e) => handleChange(data, index)}
                    >
                      {data.label}
                    </List.Item>
                  );
                })}
              </List>
            </div>
          </div>
        )}
        {!isMedicalHistory && (
          <div className="col-10 show-second-container">
            {isSelected === "Hypertension" && (
              <div className="row assessment-hist-cont mt-2 pt-2 second-container-width">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Hypertension" : "Hypertension"}
                  </h6>
                  <hr />
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      name="duration"
                      value={addHypertension.duration}
                      onChange={handleAddHypertensionChange}
                      isError={isError.duration}
                      errorMessage="Duration field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="highest_bp"
                      type={``}
                      formLabel={`Highest Blood Pressure(mmHg)`}
                      size={`sm`}
                      name="highest_bp"
                      value={addHypertension.highest_bp}
                      onChange={handleAddHypertensionChange}
                      isError={isError.highest_bp}
                      errorMessage="Highest Blood Pressure field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="usual_bp"
                      type={``}
                      formLabel={`Usual Blood Pressure(mmHg)`}
                      size={`sm`}
                      name="usual_bp"
                      value={addHypertension.usual_bp}
                      onChange={handleAddHypertensionChange}
                      isError={isError.usual_bp}
                      errorMessage="Usual Blood Pressure field is required."
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row-reverse row">
                  <div className="col-sm-3 left show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      isClicked={showButton}
                      onClick={
                        isEdit === "edit"
                          ? updateHypertensionSubmit
                          : addHypertensionSubmit
                      }
                      disabled={
                        !addHypertension.duration ||
                        !addHypertension.highest_bp ||
                        !addHypertension.usual_bp
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["DURATION", "HIGHEST BP", "USUAL BP"]}
                      headerSelector={["duration", "highest_bp", "usual_bp"]}
                      tableData={hypertensionDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "hypertension")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Diabetes" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Diabetes" : "Diabetes"}
                  </h6>
                  <hr />
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      onChange={handleAddDiabetesChange}
                      name="duration"
                      value={addDiabetes.duration}
                      isError={isError.duration}
                      errorMessage="Duration field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="usual_fbs"
                      type={``}
                      formLabel={`Usual FBS(mg/dl)`}
                      size={`sm`}
                      onChange={handleAddDiabetesChange}
                      name="usual_fbs"
                      value={addDiabetes.usual_fbs}
                      isError={isError.usual_fbs}
                      errorMessage="Usual FBS field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="usual_rbs"
                      type={``}
                      formLabel={`Usual RBS(mg/dl)`}
                      size={`sm`}
                      onChange={handleAddDiabetesChange}
                      name="usual_rbs"
                      value={addDiabetes.usual_rbs}
                      isError={isError.usual_rbs}
                      errorMessage="Usual RBS field is required."
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextField
                      required
                      id="hba1c"
                      type={``}
                      formLabel={`HbA1c`}
                      size={`sm`}
                      onChange={handleAddDiabetesChange}
                      name="hba1c"
                      value={addDiabetes.hba1c}
                      isError={isError.hba1c}
                      errorMessage="HbA1c field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <SelectField
                      required
                      formLabel={`CBG Range`}
                      name="cbg_range"
                      size={`sm`}
                      id={"cbg_range"}
                      options={cbgRangeOptions}
                      onChange={handleAddDiabetesChange}
                      value={addDiabetes.cbg_range}
                      isError={isError.cbg_range}
                      errorMessage="CBG Range field is required."
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col-sm-6">
                    <TextField
                      required
                      id="complications"
                      name="complications"
                      type={``}
                      formLabel={`Complications`}
                      size={`sm`}
                      onChange={handleAddDiabetesChange}
                      value={addDiabetes.complications}
                      isError={isError.complications}
                      errorMessage="Complication field is required."
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row-reverse row mb-3">
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit" ? updateDiabetes : addDiabetesSubmit
                      }
                      disabled={
                        !addDiabetes.duration ||
                        !addDiabetes.usual_fbs ||
                        !addDiabetes.usual_rbs ||
                        !addDiabetes.hba1c ||
                        !addDiabetes.complications ||
                        !addDiabetes.cbg_range
                      }
                      isClicked={showButton}
                    />
                  </div>
                </div>

                <hr />

                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={[
                        "DURATION",
                        "USUAL FBS",
                        "USUAL RBS",
                        "HBA1C",
                        "CBC RANGE",
                        "COMPLICATIONS",
                      ]}
                      headerSelector={[
                        "duration",
                        "usual_fbs",
                        "usual_rbs",
                        "hba1c",
                        "cbg_range",
                        "complications",
                      ]}
                      tableData={diabetesDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "diabetes")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Thyroid Disorders" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Thyroid Disorders</h6>
                  <hr />
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextField
                      required
                      id="type"
                      type={``}
                      formLabel={`Type`}
                      size={`sm`}
                      name="type"
                      value={addThyroid.type}
                      onChange={handleAddThyroidChange}
                      isError={isError.type}
                      errorMessage="Type field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      name="duration"
                      value={addThyroid.duration}
                      onChange={handleAddThyroidChange}
                      isError={isError.duration}
                      errorMessage="Duration field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="medication"
                      type={``}
                      formLabel={`Medication`}
                      size={`sm`}
                      name="medication"
                      value={addThyroid.medication}
                      onChange={handleAddThyroidChange}
                      isError={isError.medication}
                      errorMessage="Medication field is required."
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col-3">
                    <TextField
                      required
                      id="rai"
                      type={``}
                      formLabel={`RAI`}
                      size={`sm`}
                      name="rai"
                      value={addThyroid.rai}
                      onChange={handleAddThyroidChange}
                      isError={isError.rai}
                      errorMessage="RAI field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-3">
                    <TextField
                      required
                      id="surgery"
                      type={``}
                      formLabel={`Surgery`}
                      size={`sm`}
                      name="surgery"
                      value={addThyroid.surgery}
                      onChange={handleAddThyroidChange}
                      isError={isError.surgery}
                      errorMessage="Surgery field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      required
                      id="levothyroxine"
                      type={``}
                      formLabel={`Levothyroxine Replacement / Suppression`}
                      size={`sm`}
                      name="levothyroxine"
                      value={addThyroid.levothyroxine}
                      onChange={handleAddThyroidChange}
                      isError={isError.levothyroxine}
                      errorMessage="Levothyroxine field is required."
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextArea
                      required
                      id="histopathologic"
                      formLabel={`Histopathologic Result`}
                      size={`sm`}
                      placeholder={``}
                      name="histopathologic"
                      value={addThyroid.histopathologic}
                      onChange={handleAddThyroidChange}
                      isError={isError.histopathologic}
                      errorMessage="Histopathologic field is required"
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row-reverse row pl-4">
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit" ? updateThyroid : addThyroidDisorder
                      }
                      isClicked={showButton}
                      disabled={
                        !addThyroid.type ||
                        !addThyroid.duration ||
                        !addThyroid.medication ||
                        !addThyroid.rai ||
                        !addThyroid.surgery ||
                        !addThyroid.levothyroxine ||
                        !addThyroid.histopathologic
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={[
                        "TYPE",
                        "DURATION",
                        "MEDICATION",
                        "RAI",
                        "SURGERY",
                        "LR/SUPPRESSION",
                        "HISTOPATHOLOGIC",
                      ]}
                      headerSelector={[
                        "type",
                        "duration",
                        "medication",
                        "rai",
                        "surgery",
                        "levothyroxine",
                        "histopathologic",
                      ]}
                      tableData={thyroidDatas}
                      ActionBtn={(row) => ActionBtn(row, "thyroid")}
                      withAction={true}
                      loading={showLoader}
                      // isClickable={true}
                      // rowClickPath={"/patients/profile"}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "GDM" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">GDM</h6>
                  <hr />
                </div>
                <div className="row mb-3 pl-4 pt-3">
                  <div className="row">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="aog"
                        type={``}
                        formLabel={`AOG at Diagnosis`}
                        size={`sm`}
                        name="aog"
                        onChange={handleAddGDMChange}
                        value={addGDM.aog}
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="fasting"
                        type={``}
                        formLabel={`75-gm OGTT Result Fasting`}
                        size={`sm`}
                        name="fasting"
                        onChange={handleAddGDMChange}
                        value={addGDM.fasting}
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="glucose_load_1h"
                        type={``}
                        formLabel={`1-h Post Glucose Load`}
                        size={`sm`}
                        name="glucose_load_1h"
                        onChange={handleAddGDMChange}
                        value={addGDM.glucose_load_1h}
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="glucose_load_2h"
                        type={``}
                        formLabel={`2-h Post Glucose Load`}
                        size={`sm`}
                        name="glucose_load_2h"
                        onChange={handleAddGDMChange}
                        value={addGDM.glucose_load_2h}
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="insulin_use"
                        type={``}
                        formLabel={`Insuline Use`}
                        size={`sm`}
                        name="insulin_use"
                        onChange={handleAddGDMChange}
                        value={addGDM.insulin_use}
                        disabled={showButton}
                      />
                    </div>
                    {/* <div className="col">
                      <Form.Label className="form-label align-left p-1">
                        Link to Medical Nutrition Therapy Handouts
                      </Form.Label>
                      <Radio.Group
                        name="handout_link"
                        onChange={handleAddGDMChange}
                        value={addGDM.handout_link}
                        disabled={showButton}
                      >
                        <Radio
                          value={
                            "https://youtu.be/jNYVbmVIP4A?si=SL8hP-FgxL6dSRui"
                          }
                        >
                          <a
                            href="https://youtu.be/jNYVbmVIP4A?si=SL8hP-FgxL6dSRui"
                            target="_blank"
                            rel="noreferrer"
                          >
                            link 1
                          </a>
                        </Radio>
                        <Radio
                          value={
                            "https://youtu.be/la3QF9pQmig?si=rR-6r1XxTAfmgUgh"
                          }
                        >
                          <a
                            href="https://youtu.be/la3QF9pQmig?si=rR-6r1XxTAfmgUgh"
                            target="_blank"
                            rel="noreferrer"
                          >
                            link 2
                          </a>
                        </Radio>
                        <Radio
                          value={
                            "https://youtu.be/WJqP_0pW0Zc?si=M2DPUhCTxGuHMpX5"
                          }
                        >
                          <a
                            href="https://youtu.be/WJqP_0pW0Zc?si=M2DPUhCTxGuHMpX5"
                            target="_blank"
                            rel="noreferrer"
                          >
                            link 3
                          </a>
                        </Radio>
                      </Radio.Group>
                    </div> */}
                  </div>
                </div>
                <div className="row left mb-4 pl-4 pt-2">
                  {showDeleteBtn ? (
                    <>
                      <div className="col-sm-6"></div>
                      <div className="col-sm-3 show-summarry-all-buttons">
                        <BtnDelete
                          label={"Delete Profile"}
                          size={"sm"}
                          isClicked={showButton}
                          onClick={deleteGDMSubmit}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="col-sm-9"></div>
                  )}
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={"Save"}
                      size={"sm"}
                      isClicked={showButton}
                      onClick={gdmEdit === "gdm" ? updateGDM : addGDMSubmit}
                      disabled={Object.values(addGDM).every(
                        (value) => value === ""
                      )}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Pre-GDM" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Pre-GDM</h6>
                  <hr />
                </div>
                <div className="row mb-3 pl-4 pt-3">
                  <div className="row">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="aog"
                        type={``}
                        formLabel={`AOG at Diagnosis`}
                        size={`sm`}
                        name="aog"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.aog}
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="hba1c"
                        type={``}
                        formLabel={`HbA1c (%)`}
                        size={`sm`}
                        name="hba1c"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.hba1c}
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="fasting"
                        type={``}
                        formLabel={`75-gm OGTT Result Fasting`}
                        size={`sm`}
                        name="fasting"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.fasting}
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="glucose_load_1h"
                        type={``}
                        formLabel={`1-h Post Glucose Load`}
                        size={`sm`}
                        name="glucose_load_1h"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.glucose_load_1h}
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="glucose_load_2h"
                        type={``}
                        formLabel={`2-h Post Glucose Load`}
                        size={`sm`}
                        name="glucose_load_2h"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.glucose_load_2h}
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="insulin_use"
                        type={``}
                        formLabel={`Insuline Use`}
                        size={`sm`}
                        name="insulin_use"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.insulin_use}
                        disabled={showButton}
                      />
                    </div>
                    {/* <div className="col">
                      <Form.Label className="form-label align-left p-1">
                        Link to Medical Nutrition Therapy Handouts
                      </Form.Label>
                      <Radio.Group
                        name="handout_link"
                        onChange={handleAddPreGDMChange}
                        value={addPreGDM.handout_link}
                        disabled={showButton}
                      >
                        <Radio
                          value={
                            "https://youtu.be/jNYVbmVIP4A?si=SL8hP-FgxL6dSRui"
                          }
                        >
                          <a
                            href="https://youtu.be/jNYVbmVIP4A?si=SL8hP-FgxL6dSRui"
                            target="_blank"
                            rel="noreferrer"
                          >
                            link 1
                          </a>
                        </Radio>
                        <Radio
                          value={
                            "https://youtu.be/la3QF9pQmig?si=rR-6r1XxTAfmgUgh"
                          }
                        >
                          <a
                            href="https://youtu.be/la3QF9pQmig?si=rR-6r1XxTAfmgUgh"
                            target="_blank"
                            rel="noreferrer"
                          >
                            link 2
                          </a>
                        </Radio>
                        <Radio
                          value={
                            "https://youtu.be/WJqP_0pW0Zc?si=M2DPUhCTxGuHMpX5"
                          }
                        >
                          <a
                            href="https://youtu.be/WJqP_0pW0Zc?si=M2DPUhCTxGuHMpX5"
                            target="_blank"
                            rel="noreferrer"
                          >
                            link 3
                          </a>
                        </Radio>
                      </Radio.Group>
                    </div> */}
                  </div>
                </div>
                <div className="row left mb-4 pl-4 pt-2">
                  {showDeletePreGDMBtn ? (
                    <>
                      <div className="col-sm-6"></div>
                      <div className="col-sm-3 show-summarry-all-buttons">
                        <BtnDelete
                          label={"Delete Profile"}
                          size={"sm"}
                          isClicked={showButton}
                          onClick={deletePreGDMSubmit}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="col-sm-9"></div>
                  )}
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={"Save"}
                      size={"sm"}
                      isClicked={showButton}
                      onClick={
                        preGdmEdit === "preGDM" ? updatePreGDM : addPreGDMSubmit
                      }
                      disabled={Object.values(addPreGDM).every(
                        (value) => value === ""
                      )}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Pituitary Disorders" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit"
                      ? "Edit Pituitary Disorders"
                      : "Pituitary Disorders"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-9">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addPituitary.name}
                      onChange={handleAddPituitaryChange}
                      isError={isError.name}
                      errorMessage="Name field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit"
                          ? updatePituitary
                          : addPituitaryDisorder
                      }
                      isClicked={showButton}
                      disabled={!addPituitary.name}
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME"]}
                      headerSelector={["name"]}
                      tableData={pituitaryDatas}
                      ActionBtn={(row) => ActionBtn(row, "pituitary")}
                      withAction={true}
                      loading={showLoader}
                      // isClickable={true}
                      // rowClickPath={"/patients/profile"}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Other Endocrine Diseases" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit"
                      ? "Edit Other Endocrine Disease"
                      : "Other Endocrine Disease"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-9">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addEndocrine.name}
                      onChange={handleAddEndocrineChange}
                      isError={isError.name}
                      errorMessage="Name field is required."
                      isClicked={showButton}
                    />
                  </div>
                  <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit"
                          ? updateEndocrine
                          : addEndocrineDisease
                      }
                      isClicked={showButton}
                      disabled={!addEndocrine.name}
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME"]}
                      headerSelector={["name"]}
                      tableData={endocrineDatas}
                      ActionBtn={(row) => ActionBtn(row, "endocrine")}
                      withAction={true}
                      loading={showLoader}
                      // isClickable={true}
                      // rowClickPath={"/patients/profile"}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Bronchial Asthma" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit"
                      ? "Edit Bronchial Asthma"
                      : "Bronchial Asthma"}
                  </h6>
                  <hr />
                </div>
                <div className="row mb-3 pl-4 pt-3">
                  <div className="d-flex row align-items-end">
                    <div className="col-sm-4">
                      {/* <TextField
                        required
                        id="duration"
                        type={``}
                        formLabel={`Duration`}
                        size={`sm`}
                        name="duration"
                        value={addAsthma.duration}
                        onChange={handleAddAsthmaChange}
                        isError={isError.duration}
                        errorMessage="Duration field is required."
                        disabled={showButton}
                      /> */}
                      <p className="form-label align-left">
                        Duration
                        <span className="badge">*</span>
                      </p>
                      <InputNumber
                        name="duration"
                        type="number"
                        style={{ width: "100%" }}
                        min={1}
                        value={addAsthma.duration}
                        onChange={(value) =>
                          handleAddAsthmaChange("duration", value)
                        }
                      />
                    </div>
                    <div className="col-sm-4">
                      <p className="form-label align-left">
                        Last Attack (YYYY)
                        <span className="badge">*</span>
                      </p>
                      {/* <TextField
                        required
                        id="last_attack"
                        type={``}
                        formLabel={`Last Attack(YYYY)`}
                        size={`sm`}
                        name="last_attack"
                        value={addAsthma.last_attack}
                        onChange={handleAddAsthmaChange}
                        isError={isError.last_attack}
                        errorMessage="Last attack field is required."
                        disabled={showButton}
                      /> */}
                      <DatePicker
                        name="last_attack"
                        style={{ width: "100%" }}
                        value={
                          addAsthma.last_attack
                            ? dayjs(addAsthma.last_attack, "YYYY")
                            : null
                        }
                        onChange={(date, dateString) =>
                          handleAddAsthmaChange("last_attack", dateString)
                        }
                        picker="year"
                        disabledDate={(current) =>
                          current && current > dayjs().endOf("year")
                        }
                      />
                    </div>
                    <div className="col-sm-4 align-items-end show-summarry-all-buttons">
                      <BtnSave
                        id={"green-btn"}
                        label={isEdit === "edit" ? "Save changes" : "Submit"}
                        onClick={isEdit ? updateAsthma : addBronchialAsthma}
                        isClicked={showButton}
                        disabled={!addAsthma.duration || !addAsthma.last_attack}
                      />
                    </div>
                  </div>
                </div>
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["DURATION", "LAST ATTACK"]}
                      headerSelector={["duration", "last_attack"]}
                      tableData={asthmaDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "asthma")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Other Illness" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Other Illness" : "Other Illness"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-9">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addIllness.name}
                      onChange={handleAddIllnessChange}
                      isError={isError.name}
                      errorMessage="Name field is required."
                    />
                  </div>
                  <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit" ? updateIllness : addOtherIllness
                      }
                      isClicked={showButton}
                      disabled={!addIllness.name}
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME"]}
                      headerSelector={["name"]}
                      tableData={illnessDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "illness")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Maintenance Medication" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {" "}
                    {isEdit === "edit"
                      ? "Edit Maintenance Medication"
                      : "Maintenance Medication"}
                  </h6>
                  <hr />
                </div>
                <div className="row mt-2 pt-2">
                  <div className="row pl-4 pt-2">
                    <div className="col-sm-4">
                      <TextField
                        required
                        id="generic"
                        type={``}
                        formLabel={`Generic`}
                        size={`sm`}
                        name="generic"
                        value={addMedication.generic}
                        onChange={handleAddMedicationChange}
                        isError={isError.generic}
                        errorMessage="Generic field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="brand"
                        type={``}
                        formLabel={`Brand`}
                        size={`sm`}
                        name="brand"
                        value={addMedication.brand}
                        onChange={handleAddMedicationChange}
                        // isError={isError.brand}
                        // errorMessage="Brand field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        required
                        id="preparation"
                        type={``}
                        formLabel={`Preparation`}
                        size={`sm`}
                        name="preparation"
                        value={addMedication.preparation}
                        onChange={handleAddMedicationChange}
                        isError={isError.preparation}
                        errorMessage="Preparation field is required."
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row pl-4 pt-2">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="form"
                        type={``}
                        formLabel={`Form`}
                        size={`sm`}
                        name="form"
                        value={addMedication.form}
                        onChange={handleAddMedicationChange}
                        // isError={isError.form}
                        // errorMessage="Form field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="dosage"
                        type={``}
                        formLabel={`Dosage`}
                        size={`sm`}
                        name="dosage"
                        value={addMedication.dosage}
                        onChange={handleAddMedicationChange}
                        // isError={isError.dosage}
                        // errorMessage="Dosage field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="frequency"
                        type={``}
                        formLabel={`Frequency`}
                        size={`sm`}
                        name="frequency"
                        value={addMedication.frequency}
                        onChange={handleAddMedicationChange}
                        // isError={isError.frequency}
                        // errorMessage="Frequency field is required."
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row pl-4 pt-2">
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="timing"
                        type={``}
                        formLabel={`Timing`}
                        size={`sm`}
                        name="timing"
                        value={addMedication.timing}
                        onChange={handleAddMedicationChange}
                        // isError={isError.timing}
                        // errorMessage="Timing field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        // required
                        id="duration"
                        type={``}
                        formLabel={`Duration`}
                        size={`sm`}
                        name="duration"
                        value={addMedication.duration}
                        onChange={handleAddMedicationChange}
                        // isError={isError.duration}
                        // errorMessage="Duration field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-4">
                      <SelectField
                        // required
                        // type={`inline`}
                        formLabel={`Compliance`}
                        name="compliance"
                        size={`sm`}
                        options={[
                          { value: "fair", label: "Fair" },
                          { value: "good", label: "Good" },
                          { value: "poor", label: "Poor" },
                        ]}
                        value={addMedication.compliance}
                        onChange={handleAddMedicationChange}
                        // isError={isError.compliance}
                        // errorMessage="Compliance field is required."
                        disabled={showButton}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-row-reverse row mb-3">
                  <div className="col-sm-3 me-4 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit"
                          ? updateMedication
                          : addMaintenanceMedication
                      }
                      isClicked={showButton}
                      disabled={
                        !addMedication.generic || !addMedication.preparation
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={[
                        "GENERIC",
                        "BRAND",
                        "PREPARATION",
                        "FORM",
                        "DOSAGE",
                        "FREQUENCY",
                        "TIMING",
                        "DURATION",
                        "COMPLIANCE",
                      ]}
                      headerSelector={[
                        "generic",
                        "brand",
                        "preparation",
                        "form",
                        "dosage",
                        "frequency",
                        "timing",
                        "duration",
                        "compliance",
                      ]}
                      tableData={medicationDatas}
                      loading={showLoader}
                      withAction={true}
                      ActionBtn={(row) => ActionBtn(row, "medication")}
                      // isClickable={true}
                      // rowClickPath={"/patients/profile"}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Food/Drug Allergy" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {" "}
                    {isEdit === "edit" ? "Edit Allergy" : "Allergy"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <SelectField
                      required
                      formLabel={`Type`}
                      name="type"
                      size={`sm`}
                      placeholder={"Select"}
                      options={[
                        // { value: "", label: "Select" },
                        { value: "drug", label: "Drug" },
                        { value: "food", label: "Food" },
                        { value: "others", label: "Others" },
                      ]}
                      value={addAllergy.type}
                      onChange={handleAddAllergyChange}
                      isError={isError.type}
                      errorMessage="Type field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      onChange={handleAddAllergyChange}
                      name="name"
                      value={addAllergy.name}
                      isError={isError.name}
                      errorMessage="Name field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={isEdit ? updateAllergy : addFoodAllergy}
                      isClicked={showButton}
                      disabled={!addAllergy.name}
                    />
                  </div>
                </div>

                <hr />

                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["ALLERGY", "TYPE"]}
                      headerSelector={["name", "type"]}
                      tableData={allergyData}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "allergy")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Smoking" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {" "}
                    {isEdit === "edit" ? "Edit Smoking" : "Smoking"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      name="duration"
                      onChange={handleAddSmokingChange}
                      value={addSmoking.duration}
                      isError={isError.duration}
                      errorMessage="Duration field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="sticks_per_day"
                      type={``}
                      formLabel={`Sticks Per Day`}
                      size={`sm`}
                      name="sticks_per_day"
                      onChange={handleAddSmokingChange}
                      value={addSmoking.sticks_per_day}
                      isError={isError.sticks_per_day}
                      errorMessage="Stick per day field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit" ? updateSmoking : addSmokingSubmit
                      }
                      isClicked={showButton}
                      disabled={
                        !addSmoking.duration || !addSmoking.sticks_per_day
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["DURATION", "STICKS PER DAY"]}
                      headerSelector={["duration", "sticks_per_day"]}
                      tableData={smokingDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "smoking")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Drinking" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Drinking" : "Drinking"}{" "}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <SelectField
                      // required
                      formLabel={`Frequency`}
                      name="frequency"
                      size={`sm`}
                      placeholder={"Select"}
                      options={[
                        // { value: "", label: "Select" },
                        { value: "occasional", label: "Occasional" },
                        { value: "frequent", label: "Frequent" },
                      ]}
                      value={addDrinking.frequency}
                      onChange={handleAddDrinkingChange}
                      isError={isError.frequency}
                      errorMessage="Frequency field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <SelectField
                      required
                      formLabel={`Consumption`}
                      name="consumption"
                      size={`sm`}
                      placeholder={"Select"}
                      options={[
                        // { value: "", label: "Select" },
                        { value: "light", label: "Light" },
                        { value: "moderate", label: "Moderate" },
                        { value: "heavy", label: "Heavy" },
                      ]}
                      value={addDrinking.consumption}
                      onChange={handleAddDrinkingChange}
                      isError={isError.consumption}
                      errorMessage="Consumption field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit" ? updateDrinking : addDrinkingSubmit
                      }
                      isClicked={showButton}
                    />
                  </div>
                </div>
                <hr />
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["FREQUENCY", "CONSUMPTION"]}
                      headerSelector={["frequency", "consumption"]}
                      tableData={drinkingDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "drinking")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Illicit Drug Use" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit"
                      ? "Edit Illicit Drug Use"
                      : "Illicit Drug Use"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addDrug.name}
                      onChange={handleAddDrugChange}
                      isError={isError.name}
                      errorMessage="Name field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <DateField
                      required
                      id="last_intake"
                      type={``}
                      formLabel={`Last Intake`}
                      size={`sm`}
                      name="last_intake"
                      value={addDrug.last_intake}
                      onChange={handleAddDrugChange}
                      isError={isError.last_intake}
                      errorMessage="Last intake field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={isEdit === "edit" ? updateDrug : addDrugUse}
                      isClicked={showButton}
                      disabled={!addDrug.name || !addDrug.last_intake}
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME", "LAST INTAKE"]}
                      headerSelector={["name", "last_intake"]}
                      tableData={drugDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "drug")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Herbal Use" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Herbal Use" : "Herbal Use"}
                  </h6>
                  <hr />
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addHerbal.name}
                      onChange={handleAddHerbalChange}
                      isError={isError.name}
                      errorMessage="Name field is required"
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <DateField
                      required
                      id="last_intake"
                      type={``}
                      formLabel={`Last Intake`}
                      size={`sm`}
                      name="last_intake"
                      value={addHerbal.last_intake}
                      onChange={handleAddHerbalChange}
                      isError={isError.last_intake}
                      errorMessage="Last intake field is required"
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      name="duration"
                      value={addHerbal.duration}
                      onChange={handleAddHerbalChange}
                      isError={isError.duration}
                      errorMessage="Duration field is required"
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row-reverse row mb-3">
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={isEdit === "edit" ? updateHerbal : addHerbalUse}
                      isClicked={showButton}
                      disabled={
                        !addHerbal.name ||
                        !addHerbal.last_intake ||
                        !addHerbal.duration
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME", "LAST INTAKE", "DURATION"]}
                      headerSelector={["name", "last_intake", "duration"]}
                      tableData={herbalDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "herbal")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Past Medical History" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Past Medical History</h6>
                  <hr />
                </div>
                <PastMedicalHistory onHistoryChange={notifyHistoryChange} />
              </div>
            )}
            {isSelected === "Family Past Medical History" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Family Past Medical History</h6>
                  <hr />
                </div>
                <Row className="mt-3 text-left">
                  <Row className="w-100 text-left">
                    {heredofamilialDiseases.map((d, idx) => {
                      const checked =
                        (addHeredofamilial?.default_diseases || []).includes(
                          d.value
                        ) ||
                        (addHeredofamilial?.default_diseases || []).includes(
                          d.label
                        );
                      const valKey =
                        d.value || d.label;
                      return (
                        <Col key={idx} xs={24} className="my-2">
                          <div className="d-flex flex-column gap-1">
                            <Checkbox
                              checked={checked}
                              onChange={(e) =>
                                toggleHeredoDisease(valKey, e.target.checked)
                              }
                            >
                              {d.label}
                            </Checkbox>
                            {((addHeredofamilial?.default_diseases || []).includes(
                              valKey
                            ) ||
                              checked) &&
                              d.label === "Allergy" &&
                              Array.isArray(familyInputs.Allergy) && (
                                <div className="pl-4 mt-1 d-flex flex-column gap-2">
                                  {familyInputs.Allergy.map((item, i) => (
                                    <div key={i} className="d-flex align-items-center gap-2">
                                      <Input
                                        placeholder="Enter allergy"
                                        value={item}
                                        onChange={(e) =>
                                          setFamilyDetail("Allergy", i, e.target.value)
                                        }
                                        style={{ maxWidth: 280 }}
                                      />
                                      {familyInputs.Allergy.length > 1 && (
                                        <Button
                                          icon={<DeleteOutlined />}
                                          size="small"
                                          onClick={() =>
                                            removeFamilyDetailItem("Allergy", i)
                                          }
                                        />
                                      )}
                                      {i === familyInputs.Allergy.length - 1 && (
                                        <Button
                                          type="primary"
                                          icon={<PlusOutlined />}
                                          size="small"
                                          onClick={() => addFamilyDetailItem("Allergy")}
                                        />
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            {((addHeredofamilial?.default_diseases || []).includes(
                              valKey
                            ) ||
                              checked) &&
                              d.label === "Cancer" && (
                                <div className="pl-4 mt-1 d-flex flex-column gap-2">
                                  {Array.isArray(familyInputs.Cancer) &&
                                    familyInputs.Cancer.map((item, i) => (
                                      <div key={i} className="d-flex align-items-center gap-2">
                                        <Input
                                          placeholder="Specify organ"
                                          value={item}
                                          onChange={(e) =>
                                            setFamilyDetail("Cancer", i, e.target.value)
                                          }
                                          style={{ maxWidth: 280 }}
                                        />
                                        {familyInputs.Cancer.length > 1 && (
                                          <Button
                                            icon={<DeleteOutlined />}
                                            size="small"
                                            onClick={() =>
                                              removeFamilyDetailItem("Cancer", i)
                                            }
                                          />
                                        )}
                                        {i === familyInputs.Cancer.length - 1 && (
                                          <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            size="small"
                                            onClick={() => addFamilyDetailItem("Cancer")}
                                          />
                                        )}
                                      </div>
                                    ))}
                                </div>
                              )}
                            {((addHeredofamilial?.default_diseases || []).includes(
                              valKey
                            ) ||
                              checked) &&
                              d.label === "Hepatitis" && (
                                <div className="pl-4 mt-1">
                                  <Input
                                    placeholder="Specify type"
                                    value={familyInputs.Hepatitis}
                                    onChange={(e) =>
                                      setFamilyDetail("Hepatitis", 0, e.target.value)
                                    }
                                    style={{ maxWidth: 280 }}
                                  />
                                </div>
                              )}
                            {((addHeredofamilial?.default_diseases || []).includes(
                              valKey
                            ) ||
                              checked) &&
                              d.label === "Hypertension" && (
                                <div className="pl-4 mt-1">
                                  <Input
                                    placeholder="Highest BP (mmHg)"
                                    value={familyInputs.Hypertension}
                                    onChange={(e) =>
                                      setFamilyDetail("Hypertension", 0, e.target.value)
                                    }
                                    style={{ maxWidth: 220 }}
                                  />
                                </div>
                              )}
                            {((addHeredofamilial?.default_diseases || []).includes(
                              valKey
                            ) ||
                              checked) &&
                              d.label === "Tuberculosis" && (
                                <div className="pl-4 mt-1">
                                  <Input
                                    placeholder="Pulmonary category"
                                    value={familyInputs.Tuberculosis}
                                    onChange={(e) =>
                                      setFamilyDetail("Tuberculosis", 0, e.target.value)
                                    }
                                    style={{ maxWidth: 280 }}
                                  />
                                </div>
                              )}
                            {((addHeredofamilial?.default_diseases || []).includes(
                              valKey
                            ) ||
                              checked) &&
                              d.label === "Extrapulmonary Tuberculosis" && (
                                <div className="pl-4 mt-1">
                                  <Input
                                    placeholder="Extrapulmonary category"
                                    value={familyInputs["Extrapulmonary Tuberculosis"]}
                                    onChange={(e) =>
                                      setFamilyDetail(
                                        "Extrapulmonary Tuberculosis",
                                        0,
                                        e.target.value
                                      )
                                    }
                                    style={{ maxWidth: 280 }}
                                  />
                                </div>
                              )}
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <TextField
                      id="others"
                      name="others"
                      formLabel={`Others`}
                      size={`sm`}
                      value={addHeredofamilial?.others}
                      onChange={handleAddHeredofamilialChange}
                      placeholder={`Separate disease names with comma...`}
                    />
                  </Col>
                </Row>
                <div className="d-flex flex-row-reverse row pl-4 pt-2">
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={addHeredofamilialDisease}
                      isClicked={showButton}
                    />
                  </div>
                  {showDeleteHeredofamilialBtn && (
                    <div className="col-sm-3">
                      <BtnDelete
                        label={"Delete Profile"}
                        size={"sm"}
                        isClicked={showButton}
                        onClick={deleteHeredofamilialSubmit}
                      />
                    </div>
                  )}
                </div>
              <hr />
              <div className="row justify-content-left">
                <div className="col-sm-12 overflow">
                  <AntDTable
                    tableHeaders={["DISEASE", "DESCRIPTION", "ADDED ON"]}
                    headerSelector={["disease", "description", "added_on"]}
                    tableData={heredofamilialDatas}
                    loading={showLoader}
                    isClickable={false}
                    withAction={false}
                    scroll={{ x: true }}
                  />
                </div>
              </div>
              </div>
            )}
            {isSelected === "Surgeries" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit"
                      ? "Edit Hospitalization"
                      : "Surgeries"}
                  </h6>
                  <hr />
                </div>
                <div className="row mb-3 pl-4 pt-3">
                  <div className="row">
                    <div className="col-sm-6">
                      <TextField
                        required
                        id="name"
                        type={``}
                        formLabel={`Hospital Name`}
                        size={`sm`}
                        value={addHospitalization.name}
                        // placeholder={`PHILIPPINE COMPANY`}
                        name="name"
                        onChange={handleAddHospitalizationChange}
                        isError={isError.name}
                        errorMessage="Hospital name field is required."
                        disabled={showButton}
                      />
                    </div>
                    <div className="col-sm-6">
                      <DateField
                        required
                        className="mt-0"
                        id={"admitted_on"}
                        name={"admitted_on"}
                        formLabel={"Admitted On"}
                        size={`sm`}
                        value={addHospitalization.admitted_on}
                        onChange={handleAddHospitalizationChange}
                        isError={isError.admitted_on}
                        errorMessage="Admitted on field is required"
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <TextArea
                        required
                        id="reason"
                        type={``}
                        name={"reason"}
                        formLabel={`Reason`}
                        size={`sm`}
                        value={addHospitalization.reason}
                        onChange={handleAddHospitalizationChange}
                        isError={isError.reason}
                        errorMessage="Reason field is required"
                        disabled={showButton}
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-row-reverse row mb-3">
                    <div className="col-sm-3 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Submit"}
                        onClick={
                          isEdit
                            ? updateLastHospitalization
                            : addLastHospitalization
                        }
                        isClicked={showButton}
                        disabled={
                          !addHospitalization.name ||
                          !addHospitalization.admitted_on ||
                          !addHospitalization.reason
                        }
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={[
                        "PATIENT",
                        "HOSPITAL",
                        "ADMITTED ON",
                        "REASON",
                      ]}
                      headerSelector={[
                        "patient_name",
                        "name",
                        "admitted_on",
                        "reason",
                      ]}
                      tableData={lastHospitalizationDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "hospitalization")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Vaccination" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold"> Vaccination</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-12">
                    <label className="form-label mb-1 d-block" style={{ textAlign: "left" }}>Children Immunization Code</label>
                    <Select
                      mode="multiple"
                      allowClear
                      id="child_imm_code"
                      style={{ width: "100%" }}
                      placeholder="Select"
                      options={childImmOptions}
                      value={addVax.child_imm_code || []}
                      onChange={(val) => handleAddVaxMultiChange("child_imm_code", val)}
                      status={isError.child_imm_code ? "error" : undefined}
                      optionFilterProp="label"
                    />
                  </div>
                  <div className="col-sm-12">
                    <label className="form-label mb-1 d-block" style={{ textAlign: "left" }}>Young Immunization Code</label>
                    <Select
                      mode="multiple"
                      allowClear
                      id="youngw_imm_code"
                      style={{ width: "100%" }}
                      placeholder="Select"
                      options={youngImmOptions}
                      value={addVax.youngw_imm_code || []}
                      onChange={(val) => handleAddVaxMultiChange("youngw_imm_code", val)}
                      status={isError.youngw_imm_code ? "error" : undefined}
                      optionFilterProp="label"
                    />
                  </div>
                  <div className="col-sm-12">
                    <label className="form-label mb-1 d-block" style={{ textAlign: "left" }}>Pregnant Immunization Code</label>
                    <Select
                      mode="multiple"
                      allowClear
                      id="pregw_imm_code"
                      style={{ width: "100%" }}
                      placeholder="Select"
                      options={pregImmOptions}
                      value={addVax.pregw_imm_code || []}
                      onChange={(val) => handleAddVaxMultiChange("pregw_imm_code", val)}
                      status={isError.pregw_imm_code ? "error" : undefined}
                      optionFilterProp="label"
                    />
                  </div>
                  <div className="col-sm-12">
                    <label className="form-label mb-1 d-block" style={{ textAlign: "left" }}>Elderly Immunization Code</label>
                    <Select
                      mode="multiple"
                      allowClear
                      id="elderly_imm_code"
                      style={{ width: "100%" }}
                      placeholder="Select"
                      options={elderlyImmOptions}
                      value={addVax.elderly_imm_code || []}
                      onChange={(val) => handleAddVaxMultiChange("elderly_imm_code", val)}
                      status={isError.elderly_imm_code ? "error" : undefined}
                      optionFilterProp="label"
                    />
                  </div>
                </div>

                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-12">
                    <label className="form-label mb-1 d-block" style={{ textAlign: "left" }}>Other Immunization</label>
                    <Select
                      mode="tags"
                      allowClear
                      id="other_imm"
                      style={{ width: "100%" }}
                      placeholder="Type and press Enter to add"
                      tokenSeparators={[","]}
                      notFoundContent={null}
                      value={toImmArray(addVax.other_imm)}
                      onChange={(val) => handleAddVaxMultiChange("other_imm", val)}
                    />
                  </div>
                  <div className="col-sm-3 ms-auto mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Save"}
                      onClick={isEdit === "edit" ? updateVaxProfile : addVaxProfile}
                      isClicked={showButton}
                      disabled={!hasVaxSelection}
                    />
                  </div>
                </div>
                {/* <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="lot_number"
                      type={``}
                      formLabel={`Lot Number`}
                      size={`sm`}
                      value={addVax.lot_number}
                      // placeholder={`PHILIPPINE COMPANY`}
                      name="lot_number"
                      onChange={handleAddVaxChange}
                      isError={isError.lot_number}
                    />
                  </div>
                  <div className="col-sm-4">
                    <DateField
                      required
                      id="expiry_date"
                      type={``}
                      formLabel={`Expiry Date`}
                      size={`sm`}
                      name="expiry_date"
                      onChange={handleAddVaxChange}
                      value={addVax.expiry_date}
                      isError={isError.expiry_date}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="route_injection"
                      type={``}
                      formLabel={`Side/Route of Injection`}
                      size={`sm`}
                      value={addVax.route_injection}
                      name="route_injection"
                      onChange={handleAddVaxChange}
                      isError={isError.route_injection}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-6">
                    <TextField
                      required
                      id="manufacturing_no_brand"
                      type={``}
                      formLabel={`Manufacturing No. and Brand`}
                      size={`sm`}
                      value={addVax.manufacturing_no_brand}
                      name="manufacturing_no_brand"
                      onChange={handleAddVaxChange}
                      isError={isError.manufacturing_no_brand}
                    />
                  </div>
                  <div className="col-6">
                    <SelectField
                      required
                      formLabel={`Vaccination Name`}
                      name="vax_shot_id"
                      size={`sm`}
                      id={"vax_shot_id"}
                      options={[
                        { label: "Select", value: "" },
                        ...vaccinationShots,
                      ]}
                      onChange={handleAddVaxChange}
                      value={addVax.vax_shot_id}
                      isError={isError.vax_shot_id}
                      errorMessage="Vaccine shot field is required."
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="col-sm-4">
                    <DateField
                      required
                      id="taken_on"
                      type={``}
                      formLabel={`Last Taken On`}
                      size={`sm`}
                      name="taken_on"
                      onChange={handleAddVaxChange}
                      value={addVax.taken_on}
                      isError={isError.taken_on}
                      errorMessage="Last taken on field is required."
                    />
                  </div>
                  <div className="col-sm-4">
                    <DateField
                      id="next_shot_on"
                      type={``}
                      formLabel={`Next Taken On`}
                      size={`sm`}
                      name="next_shot_on"
                      onChange={handleAddVaxChange}
                      value={addVax.next_shot_on}
                    />
                  </div>

                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit" ? updateVaxProfile : addVaxProfile
                        }
                        isClicked={showButton}
                        value={addVax.taken_on}
                        disabled={
                          !addVax.vax_shot_id ||
                          !addVax.lot_number ||
                          !addVax.expiry_date ||
                          !addVax.route_injection ||
                          !addVax.manufacturing_no_brand ||
                          !addVax.taken_on
                        }
                      />
                    </div>
                  </div>
                </div> */}
                <hr />

                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    {/* <AntDTable
                      tableHeaders={[
                        "LOT NUMBER",
                        "EXPIRY DATE",
                        "SIDE/ROUTE",
                        "MANUFACTURING NO. & BRAND",
                        "VACCINATION NAME",
                        "LAST TAKEN ON",
                        "NEXT TAKEN ON",
                      ]}
                      headerSelector={[
                        "lot_number",
                        "expiry_date",
                        "route_injection",
                        "manufacturing_no_brand",
                        "vax_name",
                        "_taken_on",
                        "_next_shot_on",
                      ]}
                      ActionBtn={(row) => ActionBtn(row, "vaccination")}
                      tableData={vaxShot}
                      loading={showLoader}
                      withAction={true}
                    /> */}
                    <AntDTable
                      tableHeaders={["TYPE", "IMMUNIZATION"]}
                      headerSelector={["imm_type", "imm_description"]}
                      ActionBtn={(row) => ActionBtn(row, "vaccination")}
                      tableData={vaxTableRows}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Cancer" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold"> Cancer</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="organ"
                      type={``}
                      formLabel={`Organ`}
                      size={`sm`}
                      value={addCancer.organ}
                      name="organ"
                      onChange={handleAddCancerChange}
                      isError={isError.organ}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updateCancerProfile
                            : addCancerProfile
                        }
                        isClicked={showButton}
                        value={addCancer.organ}
                        disabled={!addCancer.organ}
                      />
                    </div>
                  </div>
                </div>
                <hr />

                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["ORGAN"]}
                      headerSelector={["organ"]}
                      ActionBtn={(row) => ActionBtn(row, "cancer")}
                      tableData={cancerDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Family Cancer Profile" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Family Cancer Profile</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="organ"
                      type={``}
                      formLabel={`Organ`}
                      size={`sm`}
                      value={addCancerFamily?.organ}
                      name="organ"
                      onChange={handleAddFamilyCancerChange}
                      isError={isError.organ}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updateCancerFamilyProfile
                            : addCancerFamilyProfile
                        }
                        isClicked={showButton}
                        value={addCancerFamily?.organ}
                        disabled={!addCancerFamily?.organ}
                      />
                    </div>
                  </div>
                </div>
                <hr />

                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["ORGAN"]}
                      headerSelector={["organ"]}
                      ActionBtn={(row) =>
                        ActionBtn(row, "family_cancer_profile")
                      }
                      tableData={cancerFamilyDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Hepatitis" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Hepatitis</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="type"
                      type={``}
                      formLabel={`Type`}
                      size={`sm`}
                      value={addHepatitis?.type}
                      name="type"
                      onChange={handleAddHepatitisChange}
                      isError={isError.type}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updateHepatitisProfile
                            : addHepatitisProfile
                        }
                        isClicked={showButton}
                        value={addHepatitis?.type}
                        disabled={!addHepatitis?.type}
                      />
                    </div>
                  </div>
                </div>
                <hr />

                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["TYPE"]}
                      headerSelector={["type"]}
                      ActionBtn={(row) => ActionBtn(row, "hepatitis")}
                      tableData={hepatitisDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Family Hepatitis Profile" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Family Hepatitis Profile</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="type"
                      type={``}
                      formLabel={`Type`}
                      size={`sm`}
                      value={addHepatitisFamily?.type}
                      name="type"
                      onChange={handleAddFamilyHepatitisChange}
                      isError={isError.type}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updateHepatitisFamilyProfile
                            : addHepatitisFamilyProfile
                        }
                        isClicked={showButton}
                        value={addHepatitisFamily?.type}
                        disabled={!addHepatitisFamily?.type}
                      />
                    </div>
                  </div>
                </div>
                <hr />

                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["TYPE"]}
                      headerSelector={["type"]}
                      ActionBtn={(row) =>
                        ActionBtn(row, "family_hepatitis_profile")
                      }
                      tableData={hepatitisFamilyDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}

            {isSelected === "Pulmonary Tuberculosis" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Pulmonary Tuberculosis</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="category"
                      type={``}
                      formLabel={`CATEGORY`}
                      size={`sm`}
                      value={addPulmonaryTB.category}
                      name="category"
                      onChange={handleAddPulmonaryTBChange}
                      isError={isError.category}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updatePulmonaryTBProfile
                            : addPulmonaryTBProfile
                        }
                        isClicked={showButton}
                        value={addPulmonaryTB.category}
                        disabled={!addPulmonaryTB.category}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["CATEGORY"]}
                      headerSelector={["category"]}
                      ActionBtn={(row) => ActionBtn(row, "pulmonary_tb")}
                      tableData={pulmonaryTBDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}

            {isSelected === "Family Pulmonary Tuberculosis Profile" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    Family Pulmonary Tuberculosis Profile
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="category"
                      type={``}
                      formLabel={`CATEGORY`}
                      size={`sm`}
                      value={addPulmonaryTBFamily.category}
                      name="category"
                      onChange={handleAddFamilyPulmonaryTBChange}
                      isError={isError.category}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updatePulmonaryTBFamilyProfile
                            : addPulmonaryTBFamilyProfile
                        }
                        isClicked={showButton}
                        value={addPulmonaryTBFamily.category}
                        disabled={!addPulmonaryTBFamily.category}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["CATEGORY"]}
                      headerSelector={["category"]}
                      ActionBtn={(row) => ActionBtn(row, "family_pulmonary_tb")}
                      tableData={pulmonaryTBFamilyDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}

            {isSelected === "Extrapulmonary Tuberculosis" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Extrapulmonary Tuberculosis</h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="category"
                      type={``}
                      formLabel={`CATEGORY`}
                      size={`sm`}
                      value={addExtrapulmonaryTB.category}
                      name="category"
                      onChange={handleAddPExtrapulmonaryTBChange}
                      isError={isError.category}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updateExtrapulmonaryTBProfile
                            : addExtrapulmonaryTBProfile
                        }
                        isClicked={showButton}
                        value={addExtrapulmonaryTB.category}
                        disabled={!addExtrapulmonaryTB.category}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["CATEGORY"]}
                      headerSelector={["category"]}
                      ActionBtn={(row) => ActionBtn(row, "extrapulmonary_tb")}
                      tableData={extrapulmonaryTBDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}

            {isSelected === "Family Extrapulmonary Tuberculosis Profile" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    Family Extrapulmonary Tuberculosis Profile
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="category"
                      type={``}
                      formLabel={`CATEGORY`}
                      size={`sm`}
                      value={addExtrapulmonaryTBFamily.category}
                      name="category"
                      onChange={handleAddFamilyExtrapulmonaryTBChange}
                      isError={isError.category}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? updateExtrapulmonaryTBFamilyProfile
                            : addExtrapulmonaryTBFamilyProfile
                        }
                        isClicked={showButton}
                        value={addExtrapulmonaryTBFamily.category}
                        disabled={!addExtrapulmonaryTBFamily.category}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["CATEGORY"]}
                      headerSelector={["category"]}
                      ActionBtn={(row) =>
                        ActionBtn(row, "family_extrapulmonary_tb")
                      }
                      tableData={extrapulmonaryTBFamilyDatas}
                      loading={showLoader}
                      withAction={true}
                    />
                  </div>
                </div>
              </div>
            )}

            {isSelected === "OB-Gyne History" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">OB-Gyne History</h6>
                  <hr />
                </div>
                <fieldset
                  hidden={
                    showLoader ||
                    (obgyneDatas.length > 0 && isEdit !== "edit")
                  }
                  disabled={
                    showLoader ||
                    (obgyneDatas.length > 0 && isEdit !== "edit")
                  }
                  className="border-0 p-0 m-0"
                >
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <NumberInput
                      id="menarche"
                      name="menarche"
                      formLabel={`Age of First Menstruation (Menarche)`}
                      size={`sm`}
                      maxLength={2}
                      value={addObgyneHistory.menarche}
                      onChange={handleObgyneChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <DateField
                      id="last_mens_period"
                      name="last_mens_period"
                      formLabel={`Date of Last Menstrual Period`}
                      size={`sm`}
                      value={addObgyneHistory.last_mens_period}
                      onChange={handleObgyneChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <NumberInput
                      id="period_duration"
                      name="period_duration"
                      formLabel={`Duration of Menstrual Period (days)`}
                      size={`sm`}
                      value={addObgyneHistory.period_duration}
                      onChange={handleObgyneChange}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <NumberInput
                      id="mens_interval"
                      name="mens_interval"
                      formLabel={`Interval/Cycle of Menstruation (days)`}
                      size={`sm`}
                      value={addObgyneHistory.mens_interval}
                      onChange={handleObgyneChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <NumberInput
                      id="pads_per_day"
                      name="pads_per_day"
                      formLabel={`e. Number of Pads/Napkins per Day`}
                      size={`sm`}
                      value={addObgyneHistory.pads_per_day}
                      onChange={handleObgyneChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <NumberInput
                      id="onset_sex_ic"
                      name="onset_sex_ic"
                      formLabel={`Onset of Sexual Intercourse (Age)`}
                      size={`sm`}
                      maxLength={2}
                      value={addObgyneHistory.onset_sex_ic}
                      onChange={handleObgyneChange}
                    />
                  </div>
                </div>
                <div className="d-flex row align-items-end pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      id="birth_ctrl_method"
                      name="birth_ctrl_method"
                      formLabel={`Birth Control Method Used`}
                      size={`sm`}
                      maxLength={21}
                      value={addObgyneHistory.birth_ctrl_method}
                      onChange={handleObgyneChange}
                    />
                  </div>
                  <div className="col-sm-4">
                    <p className="form-label align-left">Is Menopause?</p>
                    <div className="d-flex align-items-center mt-2">
                      <Radio.Group
                        name="is_menopause"
                        value={addObgyneHistory?.is_menopause}
                        onChange={handleObgyneChange}
                      >
                        <Radio value="Y">Yes</Radio>
                        <Radio value="N">No</Radio>
                      </Radio.Group>
                    </div>
                  </div>
                  {addObgyneHistory?.is_menopause === "Y" && (
                    <div className="col-sm-4">
                      <NumberInput
                        id="menopause_age"
                        name="menopause_age"
                        formLabel={`Age of Menopause`}
                        size={`sm`}
                        maxLength={2}
                        value={addObgyneHistory.menopause_age}
                        onChange={handleObgyneChange}
                      />
                    </div>
                  )}
                </div>
                <hr />
                <div className="row ms-3">
                  <div className="col-12 mb-3">
                    <div className="row align-items-left">
                      <div className="col-6 align-left">
                        <p className="form-label mb-0">
                          With access to family planning counselling?
                        </p>
                      </div>
                      <div className="col-6">
                        <Radio.Group
                          className="d-flex gap-3"
                          name="has_family_planning"
                          value={addObgyneHistory?.has_family_planning}
                          onChange={handleObgyneChange}
                        >
                          <Radio value="1">Yes</Radio>
                          <Radio value="0">No</Radio>
                        </Radio.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="row align-items-left">
                      <div className="col-6 align-left">
                        <p className="form-label mb-0">
                          Is pregnancy history applicable?
                        </p>
                      </div>
                      <div className="col-6">
                        <Radio.Group
                          className="d-flex gap-3"
                          name="is_pregnancy_history_applicable"
                          value={addObgyneHistory?.is_pregnancy_history_applicable}
                          onChange={handleObgyneChange}
                        >
                          <Radio value="1">Yes</Radio>
                          <Radio value="0">No</Radio>
                        </Radio.Group>
                      </div>
                    </div>
                  </div>
                  {addObgyneHistory?.is_pregnancy_history_applicable === "1" && (
                    <div className="col-12 mb-3">
                      <div className="row align-items-left">
                        <div className="col-6 align-left">
                          <p className="form-label mb-0">
                            With pregnancy-induced hypertension (pre-eclampsia)?
                          </p>
                        </div>
                        <div className="col-6">
                          <Radio.Group
                            className="d-flex gap-3"
                            name="preg_ind_hyp"
                            value={addObgyneHistory?.preg_ind_hyp}
                            onChange={handleObgyneChange}
                          >
                            <Radio value="Y">Yes</Radio>
                            <Radio value="N">No</Radio>
                          </Radio.Group>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {addObgyneHistory?.is_pregnancy_history_applicable === "1" && (
                  <>
                  <div className="d-flex row align-items-end pl-4 pt-3">
                    <div className="col-sm-4">
                      <TextField
                        id="gravidity"
                        type={``}
                        formLabel={`GRAVIDITY (No. of pregnancy)`}
                        size={`sm`}
                        value={addObgyneHistory.gravidity}
                        name="gravidity"
                        onChange={handleObgyneChange}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        id="parity"
                        type={``}
                        formLabel={`PARITY (No. of delivery)`}
                        size={`sm`}
                        value={addObgyneHistory.parity}
                        name="parity"
                        onChange={handleObgyneChange}
                        isError={isError.parity}
                      />
                    </div>
                    <div className="col-sm-4">
                      <SelectField
                        formLabel={`TYPE OF DELIVERY`}
                        size={`sm`}
                        showPlaceholder
                        options={deliveryTypeOptions}
                        value={addObgyneHistory.delivery_type}
                        name="delivery_type"
                        onChange={handleObgyneChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex row align-items-end pl-4 pt-3">
                    <div className="col-sm-4">
                      <TextField
                        id="full_term_cnt"
                        type={``}
                        formLabel={`FULL TERM (No. of pregnancy)`}
                        size={`sm`}
                        value={addObgyneHistory.full_term_cnt}
                        name="full_term_cnt"
                        onChange={handleObgyneChange}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        id="premature_cnt"
                        type={``}
                        formLabel={`PREMATURE (No. of pregnancy)`}
                        size={`sm`}
                        value={addObgyneHistory.premature_cnt}
                        name="premature_cnt"
                        onChange={handleObgyneChange}
                      />
                    </div>
                    <div className="col-sm-4">
                      <TextField
                        id="abortion_cnt"
                        type={``}
                        formLabel={`ABORTION (No. of abortion)`}
                        size={`sm`}
                        value={addObgyneHistory.abortion_cnt}
                        name="abortion_cnt"
                        onChange={handleObgyneChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex row align-items-end pl-4 pt-3">
                    <div className="col-sm-4">
                      <TextField
                        id="living_children_cnt"
                        type={``}
                        formLabel={`LIVING CHILDREN (No. of children)`}
                        size={`sm`}
                        value={addObgyneHistory.living_children_cnt}
                        name="living_children_cnt"
                        onChange={handleObgyneChange}
                      />
                    </div>
                  </div>
                  </>
                )}
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="d-flex flex-row-reverse row">
                    <div className="col-sm-3 mb-2 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Save"}
                        onClick={
                          isEdit === "edit"
                            ? handleEditObgyneHistory
                            : handleAddObgyneHistory
                        }
                        isClicked={showButton}
                        disabled={
                          showLoader ||
                          (obgyneDatas.length > 0 && isEdit !== "edit")
                        }
                      />
                    </div>
                  </div>
                </div>
                </fieldset>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={[
                        "HAS FAMILY PLANNING",
                        "PREGNANCY HISTORY APPLICABLE",
                        "PREGNANCY-INDUCED HYPERTENSION",
                        "GRAVIDITY",
                        "PARITY",
                        "TYPE OF DELIVERY",
                        "FULL TERM",
                        "PREMATURE",
                        "ABORTION",
                        "LIVING CHILDREN",
                        "MENARCHE",
                        "LAST MENSTRUAL PERIOD",
                        "PERIOD DURATION",
                        "CYCLE INTERVAL",
                        "PADS PER DAY",
                        "ONSET OF SEXUAL INTERCOURSE",
                        "BIRTH CONTROL METHOD",
                        "MENOPAUSE",
                        "MENOPAUSE AGE",
                      ]}
                      headerSelector={[
                        "formatted_has_family_planning",
                        "formatted_is_pregnancy_history_applicable",
                        "formatted_preg_ind_hyp",
                        "gravidity",
                        "parity",
                        "formatted_delivery_type",
                        "full_term_cnt",
                        "premature_cnt",
                        "abortion_cnt",
                        "living_children_cnt",
                        "menarche",
                        "last_mens_period",
                        "period_duration",
                        "mens_interval",
                        "pads_per_day",
                        "onset_sex_ic",
                        "birth_ctrl_method",
                        "formatted_is_menopause",
                        "menopause_age",
                      ]}
                      ActionBtn={(row) => ActionBtn(row, "obgyne")}
                      tableData={obgyneDatas}
                      loading={showLoader}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={`Are you sure you want to delete?`}
        onDelete={
          isSelected === "Surgeries"
            ? deleteLastHospitalization
            : isSelected === "Food/Drug Allergy"
            ? deleteFoodAllergy
            : isSelected === "Bronchial Asthma"
            ? deleteBronchialAsthma
            : isSelected === "Diabetes"
            ? deleteDiabetes
            : isSelected === "Maintenance Medication"
            ? deleteMaintenanceMedication
            : isSelected === "Hypertension"
            ? deleteTheHypertension
            : isSelected === "Herbal Use"
            ? deleteHerbaluse
            : isSelected === "Thyroid Disorders"
            ? deleteThyroidDisorder
            : isSelected === "Other Endocrine Diseases"
            ? deleteEndocrineDisease
            : isSelected === "Pituitary Disorders"
            ? deletePituitaryDisorder
            : isSelected === "Other Illness"
            ? deleteOtherIllness
            : isSelected === "Smoking"
            ? deleteSmokingSubmit
            : isSelected === "Drinking"
            ? deleteDrinkingSubmit
            : isSelected === "Vaccination"
            ? deleteVaxProfileSubmit
            : isSelected === "Illicit Drug Use"
            ? deleteDrugUse
            : isSelected === "Cancer"
            ? deleteCancer
            : isSelected === "Family Cancer Profile"
            ? deleteFamilyCancer
            : isSelected === "Hepatitis"
            ? deleteHepatitis
            : isSelected === "Family Hepatitis Profile"
            ? deleteFamilyHepatitis
            : isSelected === "Pulmonary Tuberculosis"
            ? deletePulmonaryTB
            : isSelected === "Family Pulmonary Tuberculosis Profile"
            ? deleteFamilyPulmonaryTB
            : isSelected === "Extrapulmonary Tuberculosis"
            ? deleteExtrapulmonaryTB
            : isSelected === "Family Extrapulmonary Tuberculosis Profile"
            ? deleteFamilyExtrapulmonaryTB
            : isSelected === "OB-Gyne History"
            ? handleDeleteObgyneHistory
            : () => alert(`Error calling delete api of ${isSelected}`)
        }
      />
    </div>
  );
}
export default AddMedical;